(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7921"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7921"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7FGUX", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("51Urr")).then(()=>parcelRequire('7rSlN'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $cdeafad2ca941d33$exports = {};
$parcel$extendImportMap({
    "51Urr": "auth0-spa-js.production.esm.24308568.js"
});

(function() {
    'use strict';
    if (typeof document === 'undefined' || 'adoptedStyleSheets' in document) return;
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var hasShadyCss = 'ShadyCSS' in window && !window.ShadyCSS.nativeShadow;
    var deferredStyleSheets = [];
    var deferredDocumentStyleElements = [];
    var deferredAdopters = [];
    var adoptedSheetsRegistry = new WeakMap();
    var sheetMetadataRegistry = new WeakMap();
    var locationRegistry = new WeakMap();
    var shadowRootMap = new WeakMap();
    var observerRegistry = new WeakMap();
    var appliedActionsCursorRegistry = new WeakMap();
    var state = {
        loaded: false
    };
    var frame = {
        body: null,
        CSSStyleSheet: null
    };
    var OldCSSStyleSheet = CSSStyleSheet;
    var importPattern = /@import/;
    function checkAndPrepare(sheets, container) {
        var locationType = container === document ? 'Document' : 'ShadowRoot';
        if (!Array.isArray(sheets)) throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + locationType + ": Iterator getter is not callable.");
        if (!sheets.every(instanceOfStyleSheet)) throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + locationType + ": Failed to convert value to 'CSSStyleSheet'");
        var uniqueSheets = sheets.filter(function(value, index) {
            return sheets.indexOf(value) === index;
        });
        adoptedSheetsRegistry.set(container, uniqueSheets);
        return uniqueSheets;
    }
    function isDocumentLoading() {
        return document.readyState === 'loading';
    }
    function getAdoptedStyleSheet(location) {
        return adoptedSheetsRegistry.get(location.parentNode === document.documentElement ? document : location);
    }
    function rejectImports(contents) {
        if (contents === void 0) contents = '';
        var imports = contents.match(importPattern) || [];
        var sheetContent = contents;
        if (imports.length) {
            console.warn('@import rules are not allowed here. See https://github.com/WICG/construct-stylesheets/issues/119#issuecomment-588352418');
            imports.forEach(function(_import) {
                sheetContent = sheetContent.replace(_import, '');
            });
        }
        return sheetContent;
    }
    var cssStyleSheetMethods = [
        'addImport',
        'addPageRule',
        'addRule',
        'deleteRule',
        'insertRule',
        'removeImport',
        'removeRule'
    ];
    var illegalInvocation = 'Illegal invocation';
    function updatePrototype(proto) {
        proto.replace = function() {
            return Promise.reject(new DOMException("Can't call replace on non-constructed CSSStyleSheets."));
        };
        proto.replaceSync = function() {
            throw new DOMException("Failed to execute 'replaceSync' on 'CSSStyleSheet': Can't call replaceSync on non-constructed CSSStyleSheets.");
        };
    }
    function updateAdopters(sheet) {
        var _sheetMetadataRegistr = sheetMetadataRegistry.get(sheet), adopters = _sheetMetadataRegistr.adopters, basicStyleElement = _sheetMetadataRegistr.basicStyleElement;
        adopters.forEach(function(styleElement) {
            styleElement.innerHTML = basicStyleElement.innerHTML;
        });
    }
    var ConstructStyleSheet = function() {
        function ConstructStyleSheet() {
            var basicStyleElement = document.createElement('style');
            if (state.loaded) frame.body.appendChild(basicStyleElement);
            else {
                document.head.appendChild(basicStyleElement);
                basicStyleElement.disabled = true;
                deferredStyleSheets.push(basicStyleElement);
            }
            sheetMetadataRegistry.set(this, {
                adopters: new Map(),
                actions: [],
                basicStyleElement: basicStyleElement
            });
        }
        var _proto = ConstructStyleSheet.prototype;
        _proto.replace = function replace(contents) {
            var sanitized = rejectImports(contents);
            try {
                if (!sheetMetadataRegistry.has(this)) throw new TypeError(illegalInvocation);
                var _sheetMetadataRegistr2 = sheetMetadataRegistry.get(this), basicStyleElement = _sheetMetadataRegistr2.basicStyleElement;
                basicStyleElement.innerHTML = sanitized;
                updateAdopters(this);
                return Promise.resolve(this);
            } catch (ex) {
                return Promise.reject(ex);
            }
        };
        _proto.replaceSync = function replaceSync(contents) {
            var sanitized = rejectImports(contents);
            if (!sheetMetadataRegistry.has(this)) throw new TypeError(illegalInvocation);
            var _sheetMetadataRegistr3 = sheetMetadataRegistry.get(this), basicStyleElement = _sheetMetadataRegistr3.basicStyleElement;
            basicStyleElement.innerHTML = sanitized;
            updateAdopters(this);
            return this;
        };
        _createClass(ConstructStyleSheet, [
            {
                key: "cssRules",
                get: function get() {
                    if (!sheetMetadataRegistry.has(this)) throw new TypeError(illegalInvocation);
                    var _sheetMetadataRegistr4 = sheetMetadataRegistry.get(this), basicStyleElement = _sheetMetadataRegistr4.basicStyleElement;
                    return basicStyleElement.sheet.cssRules;
                }
            }
        ]);
        return ConstructStyleSheet;
    }();
    cssStyleSheetMethods.forEach(function(method) {
        ConstructStyleSheet.prototype[method] = function() {
            if (!sheetMetadataRegistry.has(this)) throw new TypeError(illegalInvocation);
            var args = arguments;
            var _sheetMetadataRegistr5 = sheetMetadataRegistry.get(this), adopters = _sheetMetadataRegistr5.adopters, actions = _sheetMetadataRegistr5.actions, basicStyleElement = _sheetMetadataRegistr5.basicStyleElement;
            var result = basicStyleElement.sheet[method].apply(basicStyleElement.sheet, args);
            adopters.forEach(function(styleElement) {
                if (styleElement.sheet) styleElement.sheet[method].apply(styleElement.sheet, args);
            });
            actions.push([
                method,
                args
            ]);
            return result;
        };
    });
    function instanceOfStyleSheet(instance) {
        return instance && instance.constructor === ConstructStyleSheet || instance instanceof OldCSSStyleSheet || instance instanceof frame.CSSStyleSheet;
    }
    Object.defineProperty(ConstructStyleSheet, Symbol.hasInstance, {
        configurable: true,
        value: instanceOfStyleSheet
    });
    function adoptStyleSheets(location) {
        var newStyles = document.createDocumentFragment();
        var sheets = getAdoptedStyleSheet(location);
        var observer = observerRegistry.get(location);
        for(var i = 0, len = sheets.length; i < len; i++){
            var _sheetMetadataRegistr = sheetMetadataRegistry.get(sheets[i]), adopters = _sheetMetadataRegistr.adopters, basicStyleElement = _sheetMetadataRegistr.basicStyleElement;
            var elementToAdopt = adopters.get(location);
            if (elementToAdopt) {
                observer.disconnect();
                newStyles.appendChild(elementToAdopt);
                if (!elementToAdopt.innerHTML || elementToAdopt.sheet && !elementToAdopt.sheet.cssText) elementToAdopt.innerHTML = basicStyleElement.innerHTML;
                observer.observe();
            } else {
                elementToAdopt = document.createElement('style');
                elementToAdopt.innerHTML = basicStyleElement.innerHTML;
                locationRegistry.set(elementToAdopt, location);
                appliedActionsCursorRegistry.set(elementToAdopt, 0);
                adopters.set(location, elementToAdopt);
                newStyles.appendChild(elementToAdopt);
            }
            if (location === document.head) deferredDocumentStyleElements.push(elementToAdopt);
        }
        location.insertBefore(newStyles, location.lastChild);
        for(var _i = 0, _len = sheets.length; _i < _len; _i++){
            var _sheetMetadataRegistr2 = sheetMetadataRegistry.get(sheets[_i]), _adopters = _sheetMetadataRegistr2.adopters, actions = _sheetMetadataRegistr2.actions;
            var adoptedStyleElement = _adopters.get(location);
            var cursor = appliedActionsCursorRegistry.get(adoptedStyleElement);
            if (actions.length > 0) {
                for(var _i2 = cursor, _len2 = actions.length; _i2 < _len2; _i2++){
                    var _actions$_i = actions[_i2], key = _actions$_i[0], args = _actions$_i[1];
                    adoptedStyleElement.sheet[key].apply(adoptedStyleElement.sheet, args);
                }
                appliedActionsCursorRegistry.set(adoptedStyleElement, actions.length - 1);
            }
        }
    }
    function removeExcludedStyleSheets(location, oldSheets) {
        var sheets = getAdoptedStyleSheet(location);
        for(var i = 0, len = oldSheets.length; i < len; i++){
            if (sheets.indexOf(oldSheets[i]) > -1) continue;
            var _sheetMetadataRegistr3 = sheetMetadataRegistry.get(oldSheets[i]), adopters = _sheetMetadataRegistr3.adopters;
            var observer = observerRegistry.get(location);
            var styleElement = adopters.get(location);
            if (!styleElement) styleElement = adopters.get(document.head);
            observer.disconnect();
            styleElement.parentNode.removeChild(styleElement);
            observer.observe();
        }
    }
    function adoptAndRestoreStylesOnMutationCallback(mutations) {
        if (!document) return;
        for(var i = 0, len = mutations.length; i < len; i++){
            var _mutations$i = mutations[i], addedNodes = _mutations$i.addedNodes, removedNodes = _mutations$i.removedNodes;
            for(var _i = 0, _len = removedNodes.length; _i < _len; _i++){
                var location = locationRegistry.get(removedNodes[_i]);
                if (location) adoptStyleSheets(location);
            }
            if (!hasShadyCss) for(var _i2 = 0, _len2 = addedNodes.length; _i2 < _len2; _i2++){
                var iter = document.createNodeIterator(addedNodes[_i2], NodeFilter.SHOW_ELEMENT, function(node) {
                    var shadowRoot = shadowRootMap.get(node);
                    return shadowRoot && shadowRoot.adoptedStyleSheets.length > 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                }, null, false);
                var node = void 0;
                while(node = iter.nextNode())adoptStyleSheets(shadowRootMap.get(node));
            }
        }
    }
    function createObserver(location) {
        var observer = new MutationObserver(adoptAndRestoreStylesOnMutationCallback);
        var observerTool = {
            observe: function observe() {
                observer.observe(location, {
                    childList: true,
                    subtree: true
                });
            },
            disconnect: function disconnect() {
                observer.disconnect();
            }
        };
        observerRegistry.set(location, observerTool);
        observerTool.observe();
    }
    function initPolyfill() {
        var iframe = document.createElement('iframe');
        iframe.hidden = true;
        document.body.appendChild(iframe);
        frame.body = iframe.contentWindow.document.body;
        frame.CSSStyleSheet = iframe.contentWindow.CSSStyleSheet;
        updatePrototype(iframe.contentWindow.CSSStyleSheet.prototype);
        createObserver(document.body);
        state.loaded = true;
        var fragment = document.createDocumentFragment();
        for(var i = 0, len = deferredStyleSheets.length; i < len; i++){
            deferredStyleSheets[i].disabled = false;
            fragment.appendChild(deferredStyleSheets[i]);
        }
        frame.body.appendChild(fragment);
        for(var _i = 0, _len = deferredDocumentStyleElements.length; _i < _len; _i++)fragment.appendChild(deferredDocumentStyleElements[_i]);
        document.body.insertBefore(fragment, document.body.firstChild);
        for(var _i2 = 0, _len2 = deferredAdopters.length; _i2 < _len2; _i2++)adoptStyleSheets(deferredAdopters[_i2]);
        deferredAdopters.length = 0;
        deferredStyleSheets.length = 0;
        deferredDocumentStyleElements.length = 0;
    }
    function initAdoptedStyleSheets() {
        var adoptedStyleSheetAccessors = {
            configurable: true,
            get: function get() {
                return adoptedSheetsRegistry.get(this) || [];
            },
            set: function set(sheets) {
                var oldSheets = adoptedSheetsRegistry.get(this) || [];
                checkAndPrepare(sheets, this);
                var location = this === document ? isDocumentLoading() ? this.head : this.body : this;
                var isConnected = 'isConnected' in location ? location.isConnected : document.body.contains(location);
                if (isConnected) window.requestAnimationFrame(function() {
                    adoptStyleSheets(location);
                    removeExcludedStyleSheets(location, oldSheets);
                });
                else deferredAdopters.push(location);
            }
        };
        Object.defineProperty(Document.prototype, 'adoptedStyleSheets', adoptedStyleSheetAccessors);
        if (typeof ShadowRoot !== 'undefined') {
            var attachShadow = Element.prototype.attachShadow;
            Element.prototype.attachShadow = function() {
                var location = hasShadyCss ? this : attachShadow.apply(this, arguments);
                shadowRootMap.set(this, location);
                createObserver(location);
                return location;
            };
            Object.defineProperty(ShadowRoot.prototype, 'adoptedStyleSheets', adoptedStyleSheetAccessors);
        }
    }
    updatePrototype(OldCSSStyleSheet.prototype);
    window.CSSStyleSheet = ConstructStyleSheet;
    initAdoptedStyleSheets();
    if (isDocumentLoading()) document.addEventListener('DOMContentLoaded', initPolyfill);
    else initPolyfill();
})();



/*
  DO NOT EDIT - THIS FILE IS AUTO-GENERATED VIA "npm run assemble-af-standard"
*/ const $edd9b53f740fe1f9$export$9a53b86e12874d5d = `
:root, :host {
  --font-family-montserrat: Montserrat, sans-serif;
  --airframe-color-neutral-white: #FFFFFF;
  --airframe-color-neutral-white-opacity-10: rgba(255, 255, 255, 0.1);
  --airframe-color-neutral-white-opacity-5: rgba(255, 255, 255, 0.05);
  --airframe-color-neutral-white-opacity-75: rgba(255, 255, 255, 0.75);
  --airframe-color-neutral-grey-10: #EFEFEF;
  --airframe-color-neutral-grey-10-opacity-50: rgba(239, 239, 239, 0.5);
  --airframe-color-neutral-grey-20: #DADADA;
  --airframe-color-neutral-grey-20-opacity-50: rgba(218, 218, 218, 0.5);
  --airframe-color-neutral-grey-30: #B3B3B3;
  --airframe-color-neutral-grey-40: #999999;
  --airframe-color-neutral-grey-45: #8A8A8A;
  --airframe-color-neutral-grey-45-opacity-75: rgba(138, 138, 138, 0.75);
  --airframe-color-neutral-grey-50: #717171;
  --airframe-color-neutral-grey-60: #5B6162;
  --airframe-color-neutral-grey-70: #3F4444;
  --airframe-color-neutral-grey-70-opacity-50: rgba(63, 68, 68, 0.5);
  --airframe-color-neutral-grey-80: #2D2926;
  --airframe-color-neutral-grey-80-opacity-80: rgba(45, 41, 38, 0.8);
  --airframe-color-neutral-grey-90: #110F0F;
  --airframe-color-neutral-black: #000000;
  --airframe-color-neutral-black-opacity-10: rgba(0, 0, 0, 0.1);
  --airframe-color-neutral-black-opacity-5: rgba(0, 0, 0, 0.05);
  --airframe-color-disabled-dark-on-light: #B3B3B3;
  --airframe-color-disabled-light-on-light: #EFEFEF;
  --airframe-color-disabled-mid-on-light: #DADADA;
  --airframe-color-disabled-dark-on-dark: #3F4444;
  --airframe-color-disabled-light-on-dark: #8A8A8A;
  --airframe-color-disabled-mid-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-border-on-light: #717171;
  --airframe-color-border-hover-on-light: #999999;
  --airframe-color-border-disabled-on-light: #B3B3B3;
  --airframe-color-border-on-dark: #999999;
  --airframe-color-border-hover-on-dark: #B3B3B3;
  --airframe-color-border-disabled-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-disabled-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-disabled-on-light: #8A8A8A;
  --airframe-color-foreground-normal-on-dark: #FFFFFF;
  --airframe-color-foreground-normal-on-light: #2D2926;
  --airframe-color-foreground-subtle-on-dark: #B3B3B3;
  --airframe-color-foreground-subtle-on-light: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-focus: #0084D4;
  --airframe-color-background-disabled-on-dark: #3F4444;
  --airframe-color-background-disabled-on-light: #EFEFEF;
  --airframe-color-background-high-contrast-on-dark: #FFFFFF;
  --airframe-color-background-high-contrast-on-light: #2D2926;
  --airframe-color-background-low-contrast-on-dark: #3F4444;
  --airframe-color-background-low-contrast-on-light: #DADADA;
  --airframe-color-background-mid-contrast-on-dark: #DADADA;
  --airframe-color-background-mid-contrast-on-light: #2D2926;
  --airframe-color-primary-normal: #00856C;
  --airframe-color-primary-dark: #00705C;
  --airframe-color-primary-extra-dark: #005242;
  --airframe-color-primary-light: #00AB8D;
  --airframe-color-primary-extra-light: #00C19F;
  --airframe-color-primary-extra-extra-light: #B6E1DA;
  --airframe-color-primary-extra-light-opacity-10: rgba(0, 193, 159, 0.1);
  --airframe-color-accent: #E0004D;
  --airframe-color-accent-dark: #CD063E;
  --airframe-color-accent-extra-dark: #BA0C2F;
  --airframe-color-accent-extra-light: #FF1A74;
  --airframe-color-accent-light: #FF005A;
  --airframe-color-accent-normal: #E0004D;
  --airframe-color-status-danger-dark: #CA1D26;
  --airframe-color-status-danger-extra-dark: #BA1B23;
  --airframe-color-status-danger-extra-light: #FFCCCC;
  --airframe-color-status-danger-mid-light: #FF8F8F;
  --airframe-color-status-danger-light: #FF3333;
  --airframe-color-status-danger-normal: #EB0000;
  --airframe-color-status-info-dark: #00519A;
  --airframe-color-status-info-extra-dark: #001E60;
  --airframe-color-status-info-extra-light: #B6FFFF;
  --airframe-color-status-info-light: #69C6FF;
  --airframe-color-status-info-normal: #0075DB;
  --airframe-color-status-success-dark: #197032;
  --airframe-color-status-success-extra-dark: #0E401C;
  --airframe-color-status-success-extra-light: #E5F9EB;
  --airframe-color-status-success-light: #98E8AF;
  --airframe-color-status-success-normal: #24A148;
  --airframe-color-status-warning-dark: #E3AD20;
  --airframe-color-status-warning-extra-dark: #C69214;
  --airframe-color-status-warning-extra-light: #FEF9E9;
  --airframe-color-status-warning-light: #FFE395;
  --airframe-color-status-warning-normal: #FFC72C;
  --airframe-color-brand-green: #0084D4;
  --airframe-color-brand-red: #E0004D;
  --airframe-color-brand-yellow: #FFC72C;
  --airframe-color-chart-primary-1: #00856C;
  --airframe-color-chart-primary-1-opacity-50: rgba(0, 133, 108, 0.5);
  --airframe-color-chart-primary-2:#82BFB3;
  --airframe-color-chart-primary-2-opacity-50: rgba(130, 191, 179, 0.5);
  --airframe-color-chart-primary-3: #004438;
  --airframe-color-chart-primary-3-opacity-50: rgba(0, 68, 56, 0.5);
  --airframe-color-chart-primary-4: #8DBE7E;
  --airframe-color-chart-primary-4-opacity-50: rgba(141, 190, 126, 0.5);
  --airframe-color-chart-primary-5: #005646;
  --airframe-color-chart-primary-5-opacity-50: rgba(0, 86, 70, 0.5);
  --airframe-color-chart-primary-6: #5AC2A3;
  --airframe-color-chart-primary-6-opacity-50: rgba(90, 194, 163, 0.5);
  --airframe-color-chart-primary-border: #004438;
  --airframe-color-chart-secondary-1: #00519A;
  --airframe-color-chart-secondary-2: #5FA9D3;
  --airframe-color-chart-secondary-3: #002B99;
  --airframe-color-chart-secondary-4: #5F82C8;
  --airframe-color-chart-secondary-5: #031185;
  --airframe-color-chart-secondary-6: #6193FF;
  --airframe-color-chart-secondary-border: #00519A;
  --airframe-color-chart-accessibility-1: #00856C;
  --airframe-color-chart-accessibility-2: #001E60;
  --airframe-color-chart-accessibility-3: #E0004D;
  --airframe-color-chart-accessibility-4: #FFCA38;
  --airframe-color-chart-accessibility-5: #3C1A3D;
  --airframe-color-chart-accessibility-6: #FF8200;
  --airframe-color-chart-accessibility-7: #00519A;
  --airframe-color-chart-accessibility-8: #05C3DE;
  --airframe-color-chart-accessibility-9: #9B3342;
  --airframe-color-chart-accessibility-10: #2DC84D;
  --airframe-color-chart-accessibility-11: #74550B;
  --airframe-color-chart-accessibility-12: #B2ABE2;
  --airframe-space-xxxs: 0.125rem;
  --airframe-space-xxs: 0.25rem;
  --airframe-space-xs: 0.5rem;
  --airframe-space-sm: 0.75rem;
  --airframe-space-md: 1rem;
  --airframe-space-lg: 1.5rem;
  --airframe-space-xl: 2rem;
  --airframe-space-xxl: 2.5rem;
  --airframe-space-xxxl: 3rem;
  --airframe-breakpoint-xs: 0px;
  --airframe-breakpoint-vs: 320px;
  --airframe-breakpoint-sm: 640px;
  --airframe-breakpoint-md: 1024px;
  --airframe-breakpoint-xm: 1280px;
  --airframe-breakpoint-lg: 1440px;
  --airframe-breakpoint-xl: 1920px;
}
`;
const $edd9b53f740fe1f9$export$efb1c5feba0c0693 = `
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
  ========================================================================== */
/**
* 1. Correct the line height in all browsers.
* 2. Prevent adjustments of font size after orientation changes in iOS.
*/
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
  ========================================================================== */
/**
* Remove the margin in all browsers.
*/
body {
  margin: 0;
}

/**
* Render the 'main' element consistently in IE.
*/
main {
  display: block;
}

/**
* Correct the font size and margin on 'h1' elements within 'section' and
* 'article' contexts in Chrome, Firefox, and Safari.
*/
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
  ========================================================================== */
/**
* 1. Add the correct box sizing in Firefox.
* 2. Show the overflow in Edge and IE.
*/
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd 'em' font sizing in all browsers.
*/
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
  ========================================================================== */
/**
* Remove the gray background on active links in IE 10.
*/
a {
  background-color: transparent;
}

/**
* 1. Remove the bottom border in Chrome 57-
* 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
*/
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
* Add the correct font weight in Chrome, Edge, and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd 'em' font sizing in all browsers.
*/
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
* Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/**
* Prevent 'sub' and 'sup' elements from affecting the line height in
* all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
  ========================================================================== */
/**
* Remove the border on images inside links in IE 10.
*/
img {
  border-style: none;
}

/* Forms
  ========================================================================== */
/**
* 1. Change the font styles in all browsers.
* 2. Remove the margin in Firefox and Safari.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
* Show the overflow in IE.
* 1. Show the overflow in Edge.
*/
button,
input {
  /* 1 */
  overflow: visible;
}

/**
* Remove the inheritance of text transform in Edge, Firefox, and IE.
* 1. Remove the inheritance of text transform in Firefox.
*/
button,
select {
  /* 1 */
  text-transform: none;
}

/**
* Correct the inability to style clickable types in iOS and Safari.
*/
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
* Remove the inner border and padding in Firefox.
*/
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
* Restore the focus styles unset by the previous rule.
*/
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
* Correct the padding in Firefox.
*/
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
* 1. Correct the text wrapping in Edge and IE.
* 2. Correct the color inheritance from 'fieldset' elements in IE.
* 3. Remove the padding so developers are not caught out when they zero out
*    'fieldset' elements in all browsers.
*/
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
* Add the correct vertical alignment in Chrome, Firefox, and Opera.
*/
progress {
  vertical-align: baseline;
}

/**
* Remove the default vertical scrollbar in IE 10+.
*/
textarea {
  overflow: auto;
}

/**
* 1. Add the correct box sizing in IE 10.
* 2. Remove the padding in IE 10.
*/
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
* Correct the cursor style of increment and decrement buttons in Chrome.
*/
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
* 1. Correct the odd appearance in Chrome and Safari.
* 2. Correct the outline style in Safari.
*/
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
* Remove the inner padding in Chrome and Safari on macOS.
*/
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
* 1. Correct the inability to style clickable types in iOS and Safari.
* 2. Change font properties to 'inherit' in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
  ========================================================================== */
/*
* Add the correct display in Edge, IE 10+, and Firefox.
*/
details {
  display: block;
}

/*
* Add the correct display in all browsers.
*/
summary {
  display: list-item;
}

/* Misc
  ========================================================================== */
/**
* Add the correct display in IE 10+.
*/
template {
  display: none;
}

/**
* Add the correct display in IE 10.
*/
[hidden] {
  display: none;
}

/* http://meyerweb.com/eric/tools/css/reset/ 
  v2.0 | 20110126
  License: none (public domain)
*/
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  font-size: 100%;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
`;
const $edd9b53f740fe1f9$export$db12c57796383fa1 = `
html {
  box-sizing: border-box;
  font-size: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1.25rem;
  margin: 0;
  padding: 0;
}

.airframe-normal-onlight {
  color: #2D2926;
}

.airframe-subtle-onlight {
  color: #5B6162;
}

@media print, screen {
  h6,
.heading6 {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h5,
.heading5 {
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: 0.00375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h4,
.heading4 {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.004375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h3,
.heading3 {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 0.005rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h2,
.heading2 {
    font-size: 2rem;
    font-weight: 300;
    letter-spacing: 0.006875rem;
    line-height: 2.5rem;
    margin: 0;
  }

  h1,
.heading1 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: 0.008125rem;
    line-height: 3rem;
    margin: 0;
  }

  .hero {
    font-size: 3.75rem;
    font-weight: 300;
    letter-spacing: 0.0125rem;
    line-height: 4.5rem;
    margin: 0;
  }

  label {
    font-size: 0.875rem;
    font-weight: bold;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  p {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  button {
    font-size: 0.875rem;
    font-weight: bold;
    letter-spacing: 0.058125rem;
    line-height: 1.25rem;
    text-align: center;
    margin: 0;
  }

  .airframe-caption {
    font-size: 0.875rem;
    font-weight: 300;
    letter-spacing: 0.003125rem;
    line-height: 1rem;
    text-align: center;
    margin: 0;
  }

  .airframe-footnote {
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.0025rem;
    line-height: 1rem;
    margin: 0;
  }
}
@media print, screen and (min-width: 80rem) {
  .hero {
    font-size: 5rem;
    font-weight: 300;
    letter-spacing: 0.016875rem;
    line-height: 5rem;
    margin: 0;
  }

  h1,
.heading1 {
    font-size: 3.75rem;
    font-weight: 300;
    letter-spacing: 0.0125rem;
    line-height: 4.5rem;
    margin: 0;
  }

  h2,
.heading2 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: 0.008125rem;
    line-height: 3rem;
    margin: 0;
  }

  h3,
.heading3 {
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: 0.006875rem;
    line-height: 2.5rem;
    margin: 0;
  }

  h4,
.heading4 {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 0.005rem;
    line-height: 2rem;
    margin: 0;
  }

  h5,
.heading5 {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.004375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h6,
.heading6 {
    font-size: 1.125rem;
    font-weight: bold;
    letter-spacing: 0.00375rem;
    line-height: 1.5rem;
    margin: 0;
  }
}
.airframe__button {
  appearance: none;
  background: none transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.1875rem;
  color: #2D2926;
  cursor: pointer;
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.058rem;
  line-height: 1.125rem;
  min-width: 8rem;
  padding: 0.625rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 100ms ease 0s, border-color 100ms ease 0s, transform 100ms ease 0s, box-shadow 100ms ease 0s;
  user-select: none;
}
.airframe__button:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__button:active {
  transform: translateY(1px);
}
.airframe__button:disabled, .airframe__button[disabled], .airframe__button.is-disabled, .airframe__button.is-disabled:hover {
  background-color: #EFEFEF;
  border-color: transparent;
  color: #8A8A8A;
  cursor: not-allowed;
  transform: translateY(0);
}
.airframe__button[class*=-on-dark]:disabled, .airframe__button[class*=-on-dark][disabled], .airframe__button[class*=-on-dark].is-disabled, .airframe__button[class*=-on-dark].is-disabled:hover {
  background-color: #3F4444;
  color: rgba(138, 138, 138, 0.75);
}
.airframe__button--primary, .airframe__button--primary-on-dark {
  background-color: #00856C;
  border-color: #00856C;
  color: #FFFFFF;
}
.airframe__button--primary:hover, .airframe__button--primary-on-dark:hover {
  background-color: #00C19F;
  border-color: #00C19F;
}
.airframe__button--primary:active, .airframe__button--primary-on-dark:active {
  background-color: #005242;
  border-color: #005242;
  color: #00AB8D;
}
.airframe__button--secondary {
  border-color: #00856C;
  color: #00856C;
}
.airframe__button--secondary:hover {
  border-color: #00C19F;
  color: #00C19F;
}
.airframe__button--secondary:active {
  background-color: rgba(0, 193, 159, 0.1);
  border-color: #00705C;
  color: #00705C;
}
.airframe__button--secondary-on-dark {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.airframe__button--secondary-on-dark:hover {
  border-color: #00C19F;
  color: #00C19F;
}
.airframe__button--secondary-on-dark:active {
  background-color: rgba(0, 193, 159, 0.1);
  border-color: #00705C;
  color: #00856C;
}
.airframe__button--plain {
  color: #00856C;
}
.airframe__button--plain:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #00C19F;
}
.airframe__button--plain:active {
  background-color: rgba(0, 0, 0, 0.05);
  color: #00AB8D;
}
.airframe__button--flat {
  color: #00705C;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1rem;
  border: none;
  min-width: 0;
  min-height: 0;
  padding: 0;
  text-transform: none;
}
.airframe__button--flat:hover {
  color: #00C19F;
}
.airframe__button--flat:active {
  color: #00AB8D;
}
.airframe__button--flat:disabled, .airframe__button--flat[disabled], .airframe__button--flat.is-disabled {
  background: none;
  color: #8A8A8A;
}
.airframe__button--plain-on-dark {
  color: #00AB8D;
}
.airframe__button--plain-on-dark:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.airframe__button--plain-on-dark:active {
  background-color: rgba(255, 255, 255, 0.05);
}
.airframe__button--neutral:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.airframe__button--neutral:active {
  background-color: rgba(0, 0, 0, 0.05);
}
.airframe__button--neutral-on-dark {
  color: #FFFFFF;
}
.airframe__button--neutral-on-dark:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.airframe__button--neutral-on-dark:active {
  background-color: rgba(255, 255, 255, 0.05);
}
.airframe__button--danger {
  background-color: #EB0000;
  color: #FFFFFF;
}
.airframe__button--danger:hover {
  background-color: #FF3333;
  border-color: #FF3333;
}
.airframe__button--danger:active {
  background-color: #BA1B23;
  border-color: #BA1B23;
  color: #FFCCCC;
}
.airframe__button--danger-on-dark {
  background-color: #EB0000;
  color: #FFFFFF;
}
.airframe__button--danger-on-dark:hover {
  background-color: #FF3333;
  border-color: #FF3333;
}
.airframe__button--danger-on-dark:active {
  color: #FFCCCC;
  background-color: #BA1B23;
  border-color: #BA1B23;
}
.airframe__button:hover, .airframe__button:active {
  box-shadow: none !important;
}

.airframe__link {
  color: #00856C;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  text-decoration: none;
  letter-spacing: 0.05px;
}
.airframe__link:visited {
  color: #00856C;
}
.airframe__link:hover {
  color: #00C19F;
  text-decoration: underline;
}
.airframe__link:active {
  color: #2D2926;
  text-decoration: none;
}
.airframe__link:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__link:disabled, .airframe__link[disabled], .airframe__link.is-disabled, .airframe__link.is-disabled:hover {
  color: rgba(138, 138, 138, 0.75);
  cursor: not-allowed;
  text-decoration: none;
}
.airframe__link--on-dark, .airframe__link--on-dark:active, .airframe__link--on-dark:hover, .airframe__link--on-dark:visited {
  color: #FFFFFF;
}
.airframe__link--on-dark:disabled, .airframe__link--on-dark[disabled], .airframe__link--on-dark.is-disabled, .airframe__link--on-dark.is-disabled:hover, .airframe__link--on-dark:active:disabled, .airframe__link--on-dark:active[disabled], .airframe__link--on-dark:active.is-disabled, .airframe__link--on-dark:active.is-disabled:hover, .airframe__link--on-dark:hover:disabled, .airframe__link--on-dark:hover[disabled], .airframe__link--on-dark:hover.is-disabled, .airframe__link--on-dark:hover.is-disabled:hover, .airframe__link--on-dark:visited:disabled, .airframe__link--on-dark:visited[disabled], .airframe__link--on-dark:visited.is-disabled, .airframe__link--on-dark:visited.is-disabled:hover {
  color: #8A8A8A;
}
.airframe__link--inline, .airframe__link--inline-on-dark {
  text-decoration: underline;
}
.airframe__link--inline:disabled, .airframe__link--inline[disabled], .airframe__link--inline.is-disabled, .airframe__link--inline.is-disabled:hover, .airframe__link--inline-on-dark:disabled, .airframe__link--inline-on-dark[disabled], .airframe__link--inline-on-dark.is-disabled, .airframe__link--inline-on-dark.is-disabled:hover {
  text-decoration: underline;
  color: rgba(138, 138, 138, 0.75);
}
.airframe__link--inline:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__link--inline:visited {
  color: #00519A;
}
.airframe__link--inline:hover {
  color: #00C19F;
}
.airframe__link--inline:active {
  color: #2D2926;
}
.airframe__link--inline-on-dark {
  color: #00AB8D;
}
.airframe__link--inline-on-dark:visited {
  color: #69C6FF;
}
.airframe__link--inline-on-dark:hover {
  color: #00C19F;
}
.airframe__link--inline-on-dark:active {
  color: #FFFFFF;
}
.airframe__link:hover, .airframe__link:active {
  box-shadow: none !important;
}

.airframe__checkbox {
  height: 1rem;
  width: 1rem;
  border: 0.0625rem solid #717171;
  box-sizing: border-box;
  border-radius: 0.125rem;
  background-color: #FFFFFF;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.airframe__checkbox:hover {
  border: 0.0625rem solid #00AB8D;
}
.airframe__checkbox:focus {
  border: 0.0625rem solid #717171;
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__checkbox:checked:before {
  width: 0.25rem;
  height: 0.5625rem;
  margin: 0.1875rem 0.375rem;
  border-bottom: 0.125rem solid #FFFFFF;
  border-right: 0.125rem solid #FFFFFF;
  transform: rotate(45deg);
}
.airframe__checkbox:before,
.airframe__checkbox .indeterminate:before {
  content: "";
  display: block;
}
.airframe__checkbox.indeterminate:checked:before {
  border-bottom: none !important;
  transform: rotate(90deg);
}
.airframe__checkbox:disabled, .airframe__checkbox[disabled], .airframe__checkbox:disabled:hover, .airframe__checkbox[disabled]:hover {
  background-color: #EFEFEF;
  border: 1px solid #B3B3B3;
  cursor: not-allowed;
  transform: translateY(0);
}
.airframe__checkbox:disabled:checked, .airframe__checkbox[disabled]:checked, .airframe__checkbox:disabled:checked:hover, .airframe__checkbox[disabled]:checked:hover {
  background: #B3B3B3;
  border: none;
}
.airframe__checkbox:disabled:checked:before, .airframe__checkbox[disabled]:checked:before {
  border-bottom: 0.125rem solid #EFEFEF;
  border-right: 0.125rem solid #EFEFEF;
}
.airframe__checkbox[class*=-on-dark]:disabled, .airframe__checkbox[class*=-on-dark][disabled], .airframe__checkbox[class*=-on-dark]:disabled:hover, .airframe__checkbox[class*=-on-dark][disabled]:hover {
  border: 0.0625rem solid rgba(138, 138, 138, 0.75);
  background-color: #3F4444;
}
.airframe__checkbox[class*=-on-dark]:disabled:checked, .airframe__checkbox[class*=-on-dark][disabled]:checked, .airframe__checkbox[class*=-on-dark]:disabled:checked:hover, .airframe__checkbox[class*=-on-dark][disabled]:checked:hover {
  background: rgba(138, 138, 138, 0.75);
  border: none;
}
.airframe__checkbox--primary:hover, .airframe__checkbox--primary-on-dark:hover {
  border: 0.0625rem solid #00AB8D;
}
.airframe__checkbox--primary:hover:checked, .airframe__checkbox--primary-on-dark:hover:checked {
  background-color: #00AB8D;
}
.airframe__checkbox--primary:checked, .airframe__checkbox--primary-on-dark:checked {
  background: #00856C;
  color: #FFFFFF;
  border: none;
}
.airframe__checkbox--error, .airframe__checkbox--error:hover {
  border: 0.0625rem solid #BA1B23;
}
.airframe__checkbox--error:checked, .airframe__checkbox--error:hover:checked {
  background-color: #BA1B23;
}
.airframe__checkbox--error-on-dark, .airframe__checkbox--error-on-dark:hover {
  border: 0.0625rem solid #FF8F8F;
}
.airframe__checkbox--error-on-dark:checked, .airframe__checkbox--error-on-dark:hover:checked {
  background-color: #FF8F8F;
}
.airframe__checkbox--error:checked:before, .airframe__checkbox--error-on-dark:checked:before {
  margin: 0.125rem 0.3125rem;
}

.airframe__radiogroup {
  display: block;
  position: relative;
  padding-left: 1.4375rem;
  cursor: pointer;
  height: 1.75rem;
  width: 6.75rem;
  color: #2D2926;
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
  padding-right: 1rem;
}
.airframe__radiogroup input:first-of-type {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.airframe__radiogroup span:first-of-type {
  position: absolute;
  top: 12;
  left: 0;
  height: 1rem;
  width: 1rem;
  background-color: #FFFFFF;
  border-radius: 50% !important;
  border: 0.0625rem solid #717171;
  box-sizing: border-box;
}
.airframe__radiogroup span:first-of-type:hover {
  border: 0.0625rem solid #00AB8D;
  background-color: #EFEFEF;
}
.airframe__radiogroup input:first-of-type:checked ~ span:first-of-type {
  background-color: #00856C;
  border: none;
}
.airframe__radiogroup input:hover:checked ~ span:first-of-type {
  background-color: #00AB8D;
}
.airframe__radiogroup input:focus ~ span:first-of-type {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__radiogroup span:first-of-type:after {
  top: 0.3125rem;
  left: 0.3125rem;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background: #FFFFFF;
  content: "";
  position: absolute;
  display: none;
}
.airframe__radiogroup input:first-of-type:checked ~ span:first-of-type:after {
  display: block;
}
.airframe__radiogroup_title {
  height: 1.5rem;
  width: 6.5rem;
  color: #2D2926;
  font-size: 0.875rem;
  font-weight: bold;
  letter-spacing: 0.003125rem;
  line-height: 1.5rem;
  text-align: left;
}

.airframe__toggle {
  position: relative;
  display: inline-block;
  height: 1rem;
  width: 2rem;
  border-radius: 6.25rem;
}
.airframe__toggle span:first-of-type {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #B3B3B3;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 2.125rem;
}
.airframe__toggle span:first-of-type:before {
  position: absolute;
  content: "";
  left: 0.125rem;
  bottom: 0.125rem;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 6.25rem;
  background-color: #FFFFFF;
}
.airframe__toggle input:first-of-type {
  display: none;
}
.airframe__toggle input:first-of-type:checked + span:first-of-type {
  background-color: #00856C;
}
.airframe__toggle input:first-of-type:hover:checked + span:first-of-type {
  background-color: #00AB8D;
}
.airframe__toggle input:first-of-type:hover + span:first-of-type {
  background-color: #DADADA;
}
.airframe__toggle input:first-of-type:focus + span:first-of-type {
  box-sizing: border-box;
  height: 1.375rem;
  width: 2.375rem;
  border: 0.125rem solid #0084D4;
  border-radius: 0.625rem;
  background-color: rgba(255, 255, 255, 0.75);
}
.airframe__toggle input:first-of-type:checked + span:first-of-type:before {
  -webkit-transform: translateX(1rem);
  -ms-transform: translateX(1rem);
  transform: translateX(1rem);
}

.airframe__icon-button {
  background: none transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.1875rem;
  color: #00856C;
  cursor: pointer;
  display: inline-block;
  height: 2.5rem;
  width: 2.5rem;
  transition: background-color 100ms ease 0s, border-color 100ms ease 0s, transform 100ms ease 0s;
  font-size: 1rem;
}
.airframe__icon-button:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__icon-button:hover {
  color: #00C19F;
  background-color: rgba(0, 133, 108, 0.1);
}
.airframe__icon-button:active {
  color: #005242;
  background-color: #DADADA;
  transform: translateY(1px);
}
.airframe__icon-button:hover, .airframe__icon-button:active {
  box-shadow: none !important;
}
.airframe__icon-button:disabled, .airframe__icon-button.is-disabled, .airframe__icon-button.is-disabled:hover {
  color: #8A8A8A;
  background-color: transparent;
  cursor: not-allowed;
  transform: translateY(0);
}

label.airframe__textfield {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.003125rem;
  color: #2D2926;
}
label.airframe__textfield div:first-of-type {
  font-weight: 300;
  line-height: 1rem;
  font-size: 0.875rem;
  letter-spacing: 0.003125rem;
  color: #2D2926;
  padding-top: 4px;
}
label.airframe__textfield input:first-of-type {
  margin-top: 6px;
  display: block;
  font-family: "Montserrat", sans-serif;
  outline: 0;
  height: 2.5rem;
  padding-left: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 0.125rem;
  border-width: 0.0625rem;
  border-color: #717171;
  border-style: solid;
}
label.airframe__textfield input:first-of-type::placeholder {
  font-weight: 300;
  color: #5B6162;
}
label.airframe__textfield input:first-of-type:focus {
  border-color: #0084D4;
}
label.airframe__textfield input:first-of-type:hover {
  background-color: #EFEFEF;
  border-color: #00AB8D;
}
label.airframe__textfield input:first-of-type:disabled, label.airframe__textfield input:first-of-type:disabled:hover {
  background-color: #EFEFEF;
  color: #8A8A8A;
  border-color: #717171;
  cursor: not-allowed;
}
label.airframe__textfield input:first-of-type.input-validation-error {
  border-color: #BA1B23;
}

.airframe__textfield:not(label) {
  font-family: "Montserrat", sans-serif;
  outline: 0;
  height: 2.5rem;
  padding-left: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 0.125rem;
  border-width: 0.0625rem;
  border-color: #717171;
  border-style: solid;
}
.airframe__textfield:not(label)::placeholder {
  font-weight: 300;
  color: #5B6162;
}
.airframe__textfield:not(label):focus {
  border-color: #0084D4;
}
.airframe__textfield:not(label):hover {
  background-color: #EFEFEF;
  border-color: #00AB8D;
}
.airframe__textfield:not(label):disabled, .airframe__textfield:not(label):disabled:hover {
  background-color: #EFEFEF;
  color: #8A8A8A;
  border-color: #717171;
  cursor: not-allowed;
}
.airframe__textfield:not(label).input-validation-error {
  border-color: #BA1B23;
}

.airframe__spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 12.5rem;
  height: 12.5rem;
}
.airframe__spinner-icon {
  height: 3.125rem;
  width: 3.125rem;
  border-width: 0.25rem;
  border-color: #DADADA;
  border-top-color: #00856C;
  border-style: solid;
  border-radius: 50%;
  animation: spinner 1s infinite linear;
  -webkit-animation: spinner 1s infinite linear;
}
@media (min-width: 640px) {
  .airframe__spinner-icon {
    height: 4.6875rem;
    width: 4.6875rem;
    border-width: 0.375rem;
  }
}
@media (min-width: 1280px) {
  .airframe__spinner-icon {
    height: 6.25rem;
    width: 6.25rem;
    border-width: 0.5rem;
  }
}
.airframe__spinner-text {
  padding: 0.625rem;
}
@media (max-width: 640px) {
  .airframe__spinner-text {
    font-size: 80%;
  }
}
@media (max-width: 1280px) {
  .airframe__spinner-text {
    font-size: 90%;
  }
}

@keyframes spinner {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.airframe__navigation-tabs {
  margin: auto;
  margin-bottom: 0.125rem;
  padding: 0;
  justify-content: center;
  display: flex;
}
.airframe__navigation-tabs a {
  margin: 0 0.375rem 0 0.375rem;
  text-decoration: none;
  color: #5B6162;
  cursor: pointer;
  font-size: 1.125rem;
}
.airframe__navigation-tabs a:hover {
  color: #5B6162;
  border-bottom: 2px solid #DADADA;
}
.airframe__navigation-tabs a:active {
  color: #5B6162;
  border-bottom: 2px solid #999999;
}
.airframe__navigation-tabs a.current-tab {
  border-bottom: 2px solid #00856C !important;
  color: black !important;
  cursor: context-menu;
}
`;
const $edd9b53f740fe1f9$export$44c6a27b41bcee9f = {
    'font-family-montserrat': 'Montserrat, sans-serif',
    'airframe-color-neutral-white': '#FFFFFF',
    'airframe-color-neutral-white-opacity-10': 'rgba(255, 255, 255, 0.1)',
    'airframe-color-neutral-white-opacity-5': 'rgba(255, 255, 255, 0.05)',
    'airframe-color-neutral-white-opacity-75': 'rgba(255, 255, 255, 0.75)',
    'airframe-color-neutral-grey-10': '#EFEFEF',
    'airframe-color-neutral-grey-10-opacity-50': 'rgba(239, 239, 239, 0.5)',
    'airframe-color-neutral-grey-20': '#DADADA',
    'airframe-color-neutral-grey-20-opacity-50': 'rgba(218, 218, 218, 0.5)',
    'airframe-color-neutral-grey-30': '#B3B3B3',
    'airframe-color-neutral-grey-40': '#999999',
    'airframe-color-neutral-grey-45': '#8A8A8A',
    'airframe-color-neutral-grey-45-opacity-75': 'rgba(138, 138, 138, 0.75)',
    'airframe-color-neutral-grey-50': '#717171',
    'airframe-color-neutral-grey-60': '#5B6162',
    'airframe-color-neutral-grey-70': '#3F4444',
    'airframe-color-neutral-grey-70-opacity-50': 'rgba(63, 68, 68, 0.5)',
    'airframe-color-neutral-grey-80': '#2D2926',
    'airframe-color-neutral-grey-80-opacity-80': 'rgba(45, 41, 38, 0.8)',
    'airframe-color-neutral-grey-90': '#110F0F',
    'airframe-color-neutral-black': '#000000',
    'airframe-color-neutral-black-opacity-10': 'rgba(0, 0, 0, 0.1)',
    'airframe-color-neutral-black-opacity-5': 'rgba(0, 0, 0, 0.05)',
    'airframe-color-disabled-dark-on-light': '#B3B3B3',
    'airframe-color-disabled-light-on-light': '#EFEFEF',
    'airframe-color-disabled-mid-on-light': '#DADADA',
    'airframe-color-disabled-dark-on-dark': '#3F4444',
    'airframe-color-disabled-light-on-dark': '#8A8A8A',
    'airframe-color-disabled-mid-on-dark': 'rgba(138, 138, 138, 0.75)',
    'airframe-color-border-on-light': '#717171',
    'airframe-color-border-hover-on-light': '#999999',
    'airframe-color-border-disabled-on-light': '#B3B3B3',
    'airframe-color-border-on-dark': '#999999',
    'airframe-color-border-hover-on-dark': '#B3B3B3',
    'airframe-color-border-disabled-on-dark': 'rgba(138, 138, 138, 0.75)',
    'airframe-color-foreground-disabled-on-dark': 'rgba(138, 138, 138, 0.75)',
    'airframe-color-foreground-disabled-on-light': '#8A8A8A',
    'airframe-color-foreground-normal-on-dark': '#FFFFFF',
    'airframe-color-foreground-normal-on-light': '#2D2926',
    'airframe-color-foreground-subtle-on-dark': '#B3B3B3',
    'airframe-color-foreground-subtle-on-light': 'rgba(138, 138, 138, 0.75)',
    'airframe-color-foreground-focus': '#0084D4',
    'airframe-color-background-disabled-on-dark': '#3F4444',
    'airframe-color-background-disabled-on-light': '#EFEFEF',
    'airframe-color-background-high-contrast-on-dark': '#FFFFFF',
    'airframe-color-background-high-contrast-on-light': '#2D2926',
    'airframe-color-background-low-contrast-on-dark': '#3F4444',
    'airframe-color-background-low-contrast-on-light': '#DADADA',
    'airframe-color-background-mid-contrast-on-dark': '#DADADA',
    'airframe-color-background-mid-contrast-on-light': '#2D2926',
    'airframe-color-primary-normal': '#00856C',
    'airframe-color-primary-dark': '#00705C',
    'airframe-color-primary-extra-dark': '#005242',
    'airframe-color-primary-light': '#00AB8D',
    'airframe-color-primary-extra-light': '#00C19F',
    'airframe-color-primary-extra-extra-light': '#B6E1DA',
    'airframe-color-primary-extra-light-opacity-10': 'rgba(0, 193, 159, 0.1)',
    'airframe-color-accent': '#E0004D',
    'airframe-color-accent-dark': '#CD063E',
    'airframe-color-accent-extra-dark': '#BA0C2F',
    'airframe-color-accent-extra-light': '#FF1A74',
    'airframe-color-accent-light': '#FF005A',
    'airframe-color-accent-normal': '#E0004D',
    'airframe-color-status-danger-dark': '#CA1D26',
    'airframe-color-status-danger-extra-dark': '#BA1B23',
    'airframe-color-status-danger-extra-light': '#FFCCCC',
    'airframe-color-status-danger-mid-light': '#FF8F8F',
    'airframe-color-status-danger-light': '#FF3333',
    'airframe-color-status-danger-normal': '#EB0000',
    'airframe-color-status-info-dark': '#00519A',
    'airframe-color-status-info-extra-dark': '#001E60',
    'airframe-color-status-info-extra-light': '#B6FFFF',
    'airframe-color-status-info-light': '#69C6FF',
    'airframe-color-status-info-normal': '#0075DB',
    'airframe-color-status-success-dark': '#197032',
    'airframe-color-status-success-extra-dark': '#0E401C',
    'airframe-color-status-success-extra-light': '#E5F9EB',
    'airframe-color-status-success-light': '#98E8AF',
    'airframe-color-status-success-normal': '#24A148',
    'airframe-color-status-warning-dark': '#E3AD20',
    'airframe-color-status-warning-extra-dark': '#C69214',
    'airframe-color-status-warning-extra-light': '#FEF9E9',
    'airframe-color-status-warning-light': '#FFE395',
    'airframe-color-status-warning-normal': '#FFC72C',
    'airframe-color-brand-green': '#0084D4',
    'airframe-color-brand-red': '#E0004D',
    'airframe-color-brand-yellow': '#FFC72C',
    'airframe-color-chart-primary-1': '#00856C',
    'airframe-color-chart-primary-1-opacity-50': 'rgba(0, 133, 108, 0.5)',
    'airframe-color-chart-primary-2': '#82BFB3',
    'airframe-color-chart-primary-2-opacity-50': 'rgba(130, 191, 179, 0.5)',
    'airframe-color-chart-primary-3': '#004438',
    'airframe-color-chart-primary-3-opacity-50': 'rgba(0, 68, 56, 0.5)',
    'airframe-color-chart-primary-4': '#8DBE7E',
    'airframe-color-chart-primary-4-opacity-50': 'rgba(141, 190, 126, 0.5)',
    'airframe-color-chart-primary-5': '#005646',
    'airframe-color-chart-primary-5-opacity-50': 'rgba(0, 86, 70, 0.5)',
    'airframe-color-chart-primary-6': '#5AC2A3',
    'airframe-color-chart-primary-6-opacity-50': 'rgba(90, 194, 163, 0.5)',
    'airframe-color-chart-primary-border': '#004438',
    'airframe-color-chart-secondary-1': '#00519A',
    'airframe-color-chart-secondary-2': '#5FA9D3',
    'airframe-color-chart-secondary-3': '#002B99',
    'airframe-color-chart-secondary-4': '#5F82C8',
    'airframe-color-chart-secondary-5': '#031185',
    'airframe-color-chart-secondary-6': '#6193FF',
    'airframe-color-chart-secondary-border': '#00519A',
    'airframe-color-chart-accessibility-1': '#00856C',
    'airframe-color-chart-accessibility-2': '#001E60',
    'airframe-color-chart-accessibility-3': '#E0004D',
    'airframe-color-chart-accessibility-4': '#FFCA38',
    'airframe-color-chart-accessibility-5': '#3C1A3D',
    'airframe-color-chart-accessibility-6': '#FF8200',
    'airframe-color-chart-accessibility-7': '#00519A',
    'airframe-color-chart-accessibility-8': '#05C3DE',
    'airframe-color-chart-accessibility-9': '#9B3342',
    'airframe-color-chart-accessibility-10': '#2DC84D',
    'airframe-color-chart-accessibility-11': '#74550B',
    'airframe-color-chart-accessibility-12': '#B2ABE2',
    'airframe-space-xxxs': '0.125rem',
    'airframe-space-xxs': '0.25rem',
    'airframe-space-xs': '0.5rem',
    'airframe-space-sm': '0.75rem',
    'airframe-space-md': '1rem',
    'airframe-space-lg': '1.5rem',
    'airframe-space-xl': '2rem',
    'airframe-space-xxl': '2.5rem',
    'airframe-space-xxxl': '3rem',
    'airframe-breakpoint-xs': '0px',
    'airframe-breakpoint-vs': '320px',
    'airframe-breakpoint-sm': '640px',
    'airframe-breakpoint-md': '1024px',
    'airframe-breakpoint-xm': '1280px',
    'airframe-breakpoint-lg': '1440px',
    'airframe-breakpoint-xl': '1920px'
};
var $edd9b53f740fe1f9$export$2e2bcd8739ae039 = $edd9b53f740fe1f9$export$44c6a27b41bcee9f;


const $d701cedaa1f771ef$export$e2100fa70391306f = (url)=>{
    const urlObj = new URL(url);
    return `${urlObj.origin}${urlObj.pathname.split('/').slice(0, -1).join('/')}`;
};
const $d701cedaa1f771ef$export$7b7ae612b60e1630 = (templateString)=>{
    const template = document.createElement('template');
    template.innerHTML = `${templateString}`;
    return template;
};
const $d701cedaa1f771ef$export$4ed93979f832b77b = async (path)=>{
    return await fetch(path).then(async (res)=>{
        let cssText = String(await res.text());
        if (cssText.includes('@import')) {
            console.warn(`@imports are currently disallowed due to polyfill limitations.  \nThey will be removed automatically from "${path}".\nPlease use constructable styles instead.`);
            cssText = cssText.replace(/@import(.*);/g, '');
        }
        if (cssText.includes('sourceMappingURL')) {
            console.warn(`Removing source maps from "${path}" to reduce requests and potential console warnings.`);
            cssText = cssText.replace(/^\/\*# sourceMappingURL=(.*)$/, '');
        }
        return String(cssText);
    });
};
const $d701cedaa1f771ef$export$98f4f3da3426965c = async (path)=>{
    return await $d701cedaa1f771ef$export$4ed93979f832b77b(path).then(async (rawCss)=>{
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(rawCss);
        return sheet;
    });
};
const $d701cedaa1f771ef$export$77500e5680ad5edb = (cssMarkup)=>{
    const style = new CSSStyleSheet();
    style.replaceSync(cssMarkup);
    return style;
};
const $d701cedaa1f771ef$export$dfd068eef120555c = $d701cedaa1f771ef$export$77500e5680ad5edb((0, $edd9b53f740fe1f9$export$9a53b86e12874d5d));
const $d701cedaa1f771ef$export$c3a2473505d7c415 = $d701cedaa1f771ef$export$77500e5680ad5edb((0, $edd9b53f740fe1f9$export$efb1c5feba0c0693));
const $d701cedaa1f771ef$export$892e76496edd0d6d = $d701cedaa1f771ef$export$77500e5680ad5edb((0, $edd9b53f740fe1f9$export$db12c57796383fa1));



const $3ac9a555eacd3098$var$developmentHosts = [
    'localhost',
    '127.0.0.1'
];
const $3ac9a555eacd3098$var$stagingHosts = [
    'cirium.dev',
    'rbidev.ds',
    'staging'
];
const $3ac9a555eacd3098$var$hideAccountHosts = [
    'www.cirium.com',
    'discover.cirium.com',
    'developer.cirium.com',
    'developer.studios.cirium.dev',
    'developer.studios.cirium.io',
    'auth.cirium.rbi.web.internal',
    'cirium.uat.cja.rbxd.ds'
];
const $3ac9a555eacd3098$var$shouldHideAccount = ()=>{
    const host = window.location.hostname;
    return !!$3ac9a555eacd3098$var$hideAccountHosts.find((dontShowAccountAtTheseHostnames)=>{
        return host.toLowerCase() === dontShowAccountAtTheseHostnames;
    });
};
const $3ac9a555eacd3098$export$f15d00aa73aafac4 = ()=>{
    const host = window.location.hostname;
    return !($3ac9a555eacd3098$var$developmentHosts.includes(host) || $3ac9a555eacd3098$var$stagingHosts.find((h)=>{
        return host.includes(h);
    }));
};
const $3ac9a555eacd3098$export$919daad019702595 = {
    debounce: 200,
    shadowMode: 'closed',
    logColor: 'dodgerBlue',
    logEnabled: false,
    profileAPIPath: '/api/global-header-content',
    hideAccount: $3ac9a555eacd3098$var$shouldHideAccount()
};
const $3ac9a555eacd3098$export$e9c7a10224a19f02 = {
    myCiriumHost: 'https://my-cirium.studios.cirium.dev'
};
const $3ac9a555eacd3098$export$d71d1489bc353e92 = {
    myCiriumHost: 'https://my.cirium.com'
};
const $3ac9a555eacd3098$export$e506a1d27d1eaa20 = {
    ...$3ac9a555eacd3098$export$919daad019702595,
    ...$3ac9a555eacd3098$export$f15d00aa73aafac4() ? $3ac9a555eacd3098$export$d71d1489bc353e92 : $3ac9a555eacd3098$export$e9c7a10224a19f02
};
var $3ac9a555eacd3098$export$2e2bcd8739ae039 = $3ac9a555eacd3098$export$e506a1d27d1eaa20;


const $288ce109117021f8$export$41e7a52fc0b59077 = (0, $3ac9a555eacd3098$export$2e2bcd8739ae039).shadowMode;
const $288ce109117021f8$export$bd0132c4f0a71648 = (0, $3ac9a555eacd3098$export$2e2bcd8739ae039).logColor;
const $288ce109117021f8$export$f18f86f87a0b1d85 = (0, $3ac9a555eacd3098$export$2e2bcd8739ae039).logEnabled;
class $288ce109117021f8$export$a1a7283d3ef4b3a1 extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: this.getShadowMode()
        });
        this.applyBreakpoint = this.applyBreakpoint.bind(this);
        this.getCssBreakpoints = this.getCssBreakpoints.bind(this);
    }
    adoptStyle(cssom) {
        this.shadow.adoptedStyleSheets = [
            ...this.shadow.adoptedStyleSheets,
            cssom
        ];
    }
    // making shadows only closed when they are the topmost shadow root.
    getShadowMode() {
        // Note: Updating this as a test to see of we'll be able to see the global header in FullStory.
        return 'open';
    //return this.closest("body") ? "closed" : "open";
    }
    importTemplate(template, vars, overwrite = false) {
        const clone = document.importNode((0, $d701cedaa1f771ef$export$7b7ae612b60e1630)(template({
            ...this.getAttributes(),
            ...vars
        })).content, true);
        if (overwrite) Array.from(this.shadow.children).forEach((c)=>{
            // don't touch existing style, or safari breaks.
            // seriously don't even store a reference to it,
            // or it will fail to apply new styles properly.
            if (!c.nodeName || c.nodeName.toLowerCase() !== "style") this.shadow.removeChild(c);
        });
        this.shadow.appendChild(clone);
    }
    getAttributes() {
        return this.getAttributeNames().reduce((attrs, key)=>{
            attrs[key] = this.getAttribute(key);
            return attrs;
        }, {});
    }
    getStyle(modulePath) {
        return Promise.all([
            this.loadExternalCss(`${modulePath}/styles.css`)
        ]).then(()=>{
            // needs to happen after style is appended
            this.applyBreakpoint();
        }, (e)=>{
            this.logger(`Failed to load external file ${e.currentTarget.href}`, "error");
        });
    }
    connectedCallback() {
        this.logger("mounted");
        this.applyBreakpoint();
        this.adoptStyle((0, $d701cedaa1f771ef$export$dfd068eef120555c));
        this.adoptStyle((0, $d701cedaa1f771ef$export$c3a2473505d7c415));
        window.addEventListener("resize", this.applyBreakpoint);
    }
    disconnectedCallback() {
        this.logger("unmounted");
        window.removeEventListener("resize", this.applyBreakpoint);
    }
    loadExternalCss(path = "", type = "stylesheet") {
        return new Promise((res, rej)=>{
            const link = document.createElement("link");
            link.onload = res;
            link.onerror = rej;
            link.href = path;
            link.rel = type;
            this.shadow.appendChild(link);
        });
    }
    logger(msg, type = "log") {
        if ($288ce109117021f8$export$f18f86f87a0b1d85) console[type].call(window, `%c[${this.nodeName}] ${msg}`, `color:${this.logColor || $288ce109117021f8$export$bd0132c4f0a71648}`);
    }
    get isTouch() {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
            return false;
        }
    }
    get cssPrefix() {
        return this.nodeName.toLocaleLowerCase();
    }
    async applyBreakpoint() {
        const scope = $288ce109117021f8$export$a1a7283d3ef4b3a1.prototype;
        if (!scope.__airframeBreakpointsPromise) scope.__airframeBreakpointsPromise = this.getCssBreakpoints();
        scope.__airframeBreakpoints = await scope.__airframeBreakpointsPromise;
        const width = window.document.documentElement.clientWidth;
        const bands = Object.keys(scope.__airframeBreakpoints).sort((a, b)=>{
            return scope.__airframeBreakpoints[a] - scope.__airframeBreakpoints[b];
        }).map((key, i, sortedKeys)=>{
            return {
                start: scope.__airframeBreakpoints[sortedKeys[i - 1]] || 0,
                end: scope.__airframeBreakpoints[sortedKeys[i]],
                key: key
            };
        });
        let activePoint;
        let i = 0;
        for(i = 0; i < bands.length; i++){
            if (width > bands[i].start) activePoint = bands[i].key;
            else break;
        }
        this.breakpoint = activePoint;
        const breakpointClass = `${this.cssPrefix}--breakpoint--${activePoint}`;
        if (!this.classList.contains(breakpointClass)) {
            if (this._previousBreakpoint) this.classList.remove(this._previousBreakpoint);
            this._previousBreakpoint = breakpointClass;
            this.classList.add(breakpointClass);
        }
        return true;
    }
    async getCssBreakpoints() {
        const vars = (0, $edd9b53f740fe1f9$export$2e2bcd8739ae039);
        const breakpoints = Object.keys(vars).reduce((breakpoints, key)=>{
            const val = vars[key];
            if (key.startsWith("airframe-breakpoint")) breakpoints[key.split("-").pop()] = parseInt(val);
            return breakpoints;
        }, {});
        return breakpoints;
    }
    get breakpoint() {
        return String(this.getAttribute("breakpoint")) || null;
    }
    set breakpoint(val) {
        this.setAttribute("breakpoint", String(val) || null);
    }
}
var $288ce109117021f8$export$2e2bcd8739ae039 = $288ce109117021f8$export$a1a7283d3ef4b3a1;








const $6e3794895a0fc5c6$var$modulePath = (0, $d701cedaa1f771ef$export$e2100fa70391306f)("file:///src/Button/index.js");
const $6e3794895a0fc5c6$var$style = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  .af-global-header-button__button {
    min-height: var(--airframe-space-xxl);
    min-width: auto;
    padding: 0px;
    margin: 0px;
    color: var(--airframe-color-neutral-white);
    text-transform: none;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: .4px;
  }

  button {
    margin-left: 0px !important; 
    padding-right: var(--airframe-space-sm) !important;
  }

  ::slotted(span){
    vertical-align: middle;
  }

  :host([last]) button {
    padding-right: 0px !important;
  }

  :host([breakpoint=sm]) button {
    margin: 0px !important;
    padding: 0px !important;
  }

  :host([breakpoint=sm]) ::slotted(span){
    display: none;
  }
  :host([breakpoint=vs]) ::slotted(span){
    display: none;
  }
`);
const $6e3794895a0fc5c6$var$template = (vars)=>`
  <button type="button" class="airframe__button af-global-header-button__button">
    <slot name="icon">${vars.icon}</slot>
    <slot name="label">${vars.label}</slot>
  </button>
`;
class $6e3794895a0fc5c6$export$353f5b6fc5456de1 extends (0, $288ce109117021f8$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($6e3794895a0fc5c6$var$style);
    }
    connectedCallback() {
        this.importTemplate($6e3794895a0fc5c6$var$template);
        this.render();
        super.connectedCallback();
    }
    static get observedAttributes() {
        return [
            'icon',
            'label',
            'last'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (oldVal !== newVal) this.render();
    }
    get icon() {
        return this.getAttribute('icon');
    }
    set icon(val) {
        this.setAttribute('icon', val);
    }
    get label() {
        return this.getAttribute('label');
    }
    set label(val) {
        this.setAttribute('label', val);
    }
    get last() {
        return this.hasAttribute('last');
    }
    set last(val) {
        if (val) this.setAttribute('last', '');
        else this.removeAttribute('last');
    }
    focus() {
        this.shadow.querySelector('button').focus();
    }
    render() {
        this.innerHTML = `
      <${this.icon} slot="icon"></${this.icon}>
      <span slot="label">${this.label}</span>
    `;
    }
}
window.customElements.define('af-global-header-button', $6e3794895a0fc5c6$export$353f5b6fc5456de1);




const $308f96edfe8bc0a1$var$modulePath = (0, $d701cedaa1f771ef$export$e2100fa70391306f)("file:///src/SVGIcon/index.js");
const $308f96edfe8bc0a1$var$iconStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host {
    display: inline-block;
    height: var(--airframe-space-md);
    width: var(--airframe-space-md);
    margin: var(--airframe-space-xxxs) var(--airframe-space-sm);
    padding-bottom: 3px;
    vertical-align: middle;
  }

  :host(af-svg-icon-logout){
    vertical-align: text-bottom;
  }

  svg {
    fill: var(--airframe-color-neutral-white);
  }
`);
class $308f96edfe8bc0a1$export$1776e6671850176d extends (0, $288ce109117021f8$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($308f96edfe8bc0a1$var$iconStyle);
    }
}
const $308f96edfe8bc0a1$var$dialpadTemplate = (vars)=>`
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="th" role="img" viewBox="0 0 512 512" class="svg-inline--fa fa-th fa-w-16 fa-3x">
    <path fill="currentColor" d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z" class=""></path>
  </svg>
`;
class $308f96edfe8bc0a1$export$fd1c37a5921f2480 extends $308f96edfe8bc0a1$export$1776e6671850176d {
    constructor(){
        super();
        this.importTemplate($308f96edfe8bc0a1$var$dialpadTemplate);
    }
}
const $308f96edfe8bc0a1$var$helpTemplate = (vars)=>`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"/>
  </svg>
`;
class $308f96edfe8bc0a1$export$f713256e8ad1586 extends $308f96edfe8bc0a1$export$1776e6671850176d {
    constructor(){
        super();
        this.importTemplate($308f96edfe8bc0a1$var$helpTemplate);
    }
}
const $308f96edfe8bc0a1$var$accountTemplate = (vars)=>`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
    <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/>
  </svg>
`;
class $308f96edfe8bc0a1$export$eae3a3643c1615c9 extends $308f96edfe8bc0a1$export$1776e6671850176d {
    constructor(){
        super();
        this.importTemplate($308f96edfe8bc0a1$var$accountTemplate);
    }
}
const $308f96edfe8bc0a1$var$logoutTemplate = (vars)=>`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill="currentColor" d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"/>
  </svg>
`;
class $308f96edfe8bc0a1$export$2c9e30524eeaa42e extends $308f96edfe8bc0a1$export$1776e6671850176d {
    constructor(){
        super();
        this.importTemplate($308f96edfe8bc0a1$var$logoutTemplate);
    }
}
const $308f96edfe8bc0a1$var$exitTemplate = (vars)=>`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path>
  </svg>
`;
class $308f96edfe8bc0a1$export$72b807c0098a555f extends $308f96edfe8bc0a1$export$1776e6671850176d {
    constructor(){
        super();
        this.importTemplate($308f96edfe8bc0a1$var$exitTemplate);
    }
}
window.customElements.define('af-svg-icon-dialpad', $308f96edfe8bc0a1$export$fd1c37a5921f2480);
window.customElements.define('af-svg-icon-help', $308f96edfe8bc0a1$export$f713256e8ad1586);
window.customElements.define('af-svg-icon-account', $308f96edfe8bc0a1$export$eae3a3643c1615c9);
window.customElements.define('af-svg-icon-logout', $308f96edfe8bc0a1$export$2c9e30524eeaa42e);
window.customElements.define('af-svg-icon-exit', $308f96edfe8bc0a1$export$72b807c0098a555f);





const $f8fa9f60bfeb7ba4$var$modulePath = (0, $d701cedaa1f771ef$export$e2100fa70391306f)("file:///src/LinkList/index.js");
const $f8fa9f60bfeb7ba4$var$listStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host {
    h5 {
      display: block;
      background-color: var(--airframe-color-neutral-grey-30);
    }
  }
`);
const $f8fa9f60bfeb7ba4$var$listTemplate = (vars)=>`
  <ul>
    <slot><slot>
  </ul>
`;
class $f8fa9f60bfeb7ba4$export$bec64ed398b2de33 extends (0, $288ce109117021f8$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($f8fa9f60bfeb7ba4$var$listStyle);
        this.classList.add('af-link-list');
        this.importTemplate($f8fa9f60bfeb7ba4$var$listTemplate);
    }
}
const $f8fa9f60bfeb7ba4$var$listItemStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host {
    display: list-item;
  }
  .af-link-list__link,
  .af-link-list__link:visited,
  .af-link-list__link:hover {
    font-size: 14px;
    letter-spacing: .4px;
    color: var(--airframe-color-neutral-black);
    display: block;
    line-height: 1.2;
    padding: var(--airframe-space-xs) var(--airframe-space-lg);
    text-decoration: none;
  }

  .af-link-list__link:hover,
  .af-link-list__link:focus {
    background-color: rgba(0,193,159,.25)
  }
`);
const $f8fa9f60bfeb7ba4$var$listItemTemplate = (vars)=>`
  <a class="airframe__link af-link-list__link" href="${vars.href || 'javascript:void(0);'}" target="${vars.target || ''}">
    <slot></slot>
  </a>
`;
class $f8fa9f60bfeb7ba4$export$b755d0a96e27724b extends (0, $288ce109117021f8$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($f8fa9f60bfeb7ba4$var$listItemStyle);
        this.classList.add('af-link-list__item');
    }
    connectedCallback() {
        this.importTemplate($f8fa9f60bfeb7ba4$var$listItemTemplate);
        this._linkRef = this.shadow.querySelector('.af-link-list__link');
    }
    static get observedAttributes() {
        return [
            'href',
            'target'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (this._linkRef && oldVal !== newVal) this._linkRef.setAttribute(name, newVal);
    }
    get focused() {
        return this._linkRef === this.shadow.activeElement;
    }
    set focused(val) {
        if (val) this.focus();
        else this.blur();
    }
    focus() {
        this._linkRef.focus();
    }
    blur() {
        this._linkRef.blur();
    }
    get href() {
        return this.getAttributes('href');
    }
    set href(val) {
        this.setAttributes('href', val);
    }
    get target() {
        return this.getAttributes('target');
    }
    set target(val) {
        this.setAttributes('target', val);
    }
}
const $f8fa9f60bfeb7ba4$var$listHeadingStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host {
    display: list-item;
    font-weight: 600;
    color: var(--airframe-color-primary-extra-dark);
    text-transform: uppercase;
    font-family: var(--font-family-montserrat);
    font-size: 12px;
    letter-spacing: .4px;
    line-height: 24px;
    padding: 0px;
    margin: 0px var(--airframe-space-sm);
    border-top: 1px var(--airframe-color-neutral-grey-20) solid;
  }

  :host(:first-child) {
    border-style: none;
  }
`);
const $f8fa9f60bfeb7ba4$var$listHeadingTemplate = (vars)=>`
  <slot></slot>
`;
class $f8fa9f60bfeb7ba4$export$3f53e9a9a03c5d36 extends (0, $288ce109117021f8$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($f8fa9f60bfeb7ba4$var$listHeadingStyle);
        this.classList.add('af-link-list__heading');
        this.importTemplate($f8fa9f60bfeb7ba4$var$listHeadingTemplate);
    }
}
window.customElements.define('af-link-list', $f8fa9f60bfeb7ba4$export$bec64ed398b2de33);
window.customElements.define('af-link-list-item', $f8fa9f60bfeb7ba4$export$b755d0a96e27724b);
window.customElements.define('af-link-list-heading', $f8fa9f60bfeb7ba4$export$3f53e9a9a03c5d36);




const $7c97e962aaaec607$export$bd0132c4f0a71648 = 'orange';
const $7c97e962aaaec607$export$f18f86f87a0b1d85 = false;

class $7c97e962aaaec607$export$c8be1e13970797d8 {
    // were using per-config singletons to avoid
    // any unnecessary spin up costs from repeated use.
    constructor(config){
        return this._registerInstance(config);
    }
    static _instanceRegistry = {};
    async _registerInstance(config) {
        //TODO: crc32 hash maybe?
        const instanceKey = Object.keys(config).sort().map((k)=>k + '=' + config[k]).join('&');
        const registry = $7c97e962aaaec607$export$c8be1e13970797d8._instanceRegistry;
        if (!registry[instanceKey]) {
            registry[instanceKey] = this;
            this.logger('New client');
            this.domain = config.domain;
            this.clientId = config.clientId;
            this.audience = config.audience;
            this.loginUrl = config.loginUrl;
            this.logoutUrl = config.logoutUrl;
            this.profileToken = config.profileToken;
            this.returnTo = config.returnTo;
            let authenticated = false;
            //auth0 logic here;
            if (this.domain && this.clientId) {
                this.auth0Client = await this._buildAuth0Client();
                await this._handleRedirectCallback();
                authenticated = await this.auth0Client.isAuthenticated();
            } else if (await this.loginUrl && await this.logoutUrl && await this.profileToken) authenticated = config.authenticated;
            this.authenticated = authenticated;
        } else this.logger('Using existing client');
        return registry[instanceKey];
    }
    logger(msg, type = 'log') {
        if ($7c97e962aaaec607$export$f18f86f87a0b1d85) console[type].call(window, `%c[Profile Client] ${msg}`, `color:${this.logColor || $7c97e962aaaec607$export$bd0132c4f0a71648}`);
    }
    async _buildAuth0Client() {
        const { default: createAuth0Client } = await (parcelRequire("7FGUX"));
        const auth0 = await createAuth0Client({
            domain: this.domain,
            client_id: this.clientId,
            audience: this.audience
        });
        try {
            await auth0.getTokenSilently();
        } catch (e) {
            this.logger(e.message, 'error');
        }
        return auth0;
    }
    async getProfile() {
        const token = await this.profileToken;
        return await fetch(`${(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).myCiriumHost}${(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).profileAPIPath}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(async (res)=>{
            return await res.json().then((profile)=>{
                this.addMetaTags(profile);
                return profile;
            });
        }, (e)=>{
            this.logger(e.error, 'error');
        });
    }
    async login() {
        await this.auth0Client.loginWithRedirect({
            redirect_uri: `${window.location.origin}`
        });
    }
    async logout() {
        await this.auth0Client.logout({
            returnTo: this.returnTo
        });
    }
    createMetaTag(name, value) {
        let tag = document.querySelector(`meta[name=${name}]`);
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', name);
            document.head.appendChild(tag);
        }
        tag.setAttribute('content', value);
    }
    addMetaTags(user) {
        if (user.viperGuid) this.createMetaTag('gwa_userID', user.viperGuid);
        this.createMetaTag('gwa_localVar2', user.userId);
    }
    async _handleRedirectCallback() {
        const query = window.location.search;
        if (query.includes('code=') && query.includes('state=')) {
            await this.auth0Client.handleRedirectCallback();
            //window.location.hash = window.location.hash; // workaround for FF/Edge
            window.history.replaceState({}, document.title, '/');
        }
    }
    get logoutUrl() {
        const url = this._logoutUrl;
        if (!url && this.auth0Client) return this.auth0Client.buildLogoutUrl({
            returnTo: this.returnTo
        });
        else return Promise.resolve(url);
    }
    set logoutUrl(val) {
        this._logoutUrl = val;
        return this;
    }
    get loginUrl() {
        const url = this._loginUrl;
        if (!url && this.auth0Client) return this.auth0Client.buildAuthorizeUrl({
            redirect_uri: (0, $3ac9a555eacd3098$export$2e2bcd8739ae039).myCiriumHost
        });
        else return Promise.resolve(this._loginUrl);
    }
    set loginUrl(val) {
        this._loginUrl = val;
        return this;
    }
    get signupUrl() {
        return Promise.resolve(this.loginUrl).then((url)=>url ? `${url}&screen_hint=signup` : null);
    }
    get authenticated() {
        return this.auth0Client ? this.auth0Client.isAuthenticated() : Promise.resolve(this._authenticated);
    }
    set authenticated(val) {
        this._authenticated = val;
    }
    get profileToken() {
        let token = this._profileToken;
        if (!token && this.auth0Client) return this.auth0Client.getTokenSilently({
            audience: 'cae-user-services'
        });
        else return Promise.resolve(token);
    }
    set profileToken(val) {
        this._profileToken = val;
        return this;
    }
}
var $7c97e962aaaec607$export$2e2bcd8739ae039 = $7c97e962aaaec607$export$c8be1e13970797d8;


const $19fdfb92e79308d4$var$store = new WeakMap();
class $19fdfb92e79308d4$var$Context {
    constructor(value){
        this.value = value;
    }
    get value() {
        return $19fdfb92e79308d4$var$store.get(this);
    }
    set value(val) {
        const oldValue = this.value;
        const newValue = val;
        $19fdfb92e79308d4$var$store.set(this, val);
        this.listeners.forEach((listener)=>{
            if (listener.contextChangedCallback) listener.contextChangedCallback.apply(listener, [
                newValue,
                oldValue
            ]);
        });
    }
    listeners = new Set();
    subscribe(listener) {
        if (this.listeners.has(listener)) this.unsubscribe(listener);
        this.listeners.add(listener);
    }
    unsubscribe(listener) {
        this.listeners.delete(listener);
    }
    withContext(Super) {
        const context = this;
        return class extends Super {
            constructor(){
                super();
            }
            connectedCallback() {
                context.subscribe(this);
                return super.connectedCallback();
            }
            disconnectedCallback() {
                context.unsubscribe(this);
                return super.disconnectedCallback();
            }
            get context() {
                return context.value;
            }
            set context(value) {
                context.value = value;
                return this;
            }
        };
    }
}
function $19fdfb92e79308d4$export$fd42f52fd3ae1109(initialValue = '') {
    return new $19fdfb92e79308d4$var$Context(initialValue);
}


const $e757bf3008fc0693$export$3c814b55c7cbb1fb = (0, $19fdfb92e79308d4$export$fd42f52fd3ae1109)();
var $e757bf3008fc0693$export$2e2bcd8739ae039 = $e757bf3008fc0693$export$3c814b55c7cbb1fb;




const $b46ba5220b9486e3$var$style = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host, :root {
    --menu-width : 245px;
    position: relative;
    display: inline-block;
  }

  ::slotted(af-global-header-button) {
    display: inline-block;
    height: var(--airframe-space-xxl);
  }

  .af-global-header-dropdown__panel {
    display: none;
    position: absolute;
    min-width: var(--menu-width);
    box-shadow: var(--airframe-color-neutral-grey-45-opacity-75) 0px var(--airframe-space-xxxs) var(--airframe-space-xxs) 0px;
    border-bottom: 6px solid var(--airframe-color-primary-normal);
    background-color: var(--airframe-color-neutral-white);
    text-align: left;
  }

  :host([breakpoint=sm]) .af-global-header-dropdown__panel {
    min-width: auto;
    position: fixed;
    left : 0px;
    right : 0px;
    overflow: auto;
  }

  :host([open]) .af-global-header-dropdown__panel {
    display: block !important;
  }
`);
const $b46ba5220b9486e3$var$template = ()=>`
  <slot name="label"></slot>
  <div class="af-global-header-dropdown__panel">
    <slot name="panel"></slot>
  </div>
`;
class $b46ba5220b9486e3$export$931cbfb6bfb85fc extends (0, $288ce109117021f8$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.registerDropdown();
        this.adoptStyle((0, $d701cedaa1f771ef$export$892e76496edd0d6d));
        this.adoptStyle($b46ba5220b9486e3$var$style);
        this.importTemplate($b46ba5220b9486e3$var$template);
        this._panelRef = this.shadow.querySelector('.af-global-header-dropdown__panel');
        this.render();
        this.handleEvents = this.handleEvents.bind(this);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) this.render();
    }
    static get observedAttributes() {
        return [
            'icon',
            'label',
            'panel'
        ];
    }
    connectedCallback() {
        this.classList.add('af-global-header-dropdown');
        this.addEventListener('pointerup', this.handleEvents);
        this.addEventListener('mouseenter', this.handleEvents);
        this.addEventListener('mouseleave', this.handleEvents);
        this.addEventListener('keydown', this.handleEvents);
        window.addEventListener('keydown', this.handleEvents);
        window.addEventListener('pointerup', this.handleEvents);
        (0, $288ce109117021f8$export$2e2bcd8739ae039).prototype.connectedCallback.call(this);
    }
    disconnectedCallback() {
        this.removeEventListener('pointerup', this.handleEvents);
        this.removeEventListener('mouseenter', this.handleEvents);
        this.removeEventListener('mouseleave', this.handleEvents);
        this.removeEventListener('keydown', this.handleEvents);
        window.removeEventListener('keydown', this.handleEvents);
        window.removeEventListener('pointerup', this.handleEvents);
        super.disconnectedCallback();
    }
    focusDropdownByIndex(index) {
        const menus = Array.from(this.parentNode.querySelectorAll('.af-global-header-dropdown'));
        const newTarget = menus[index];
        if (newTarget) {
            newTarget.focus();
            if (this.open) newTarget.open = true;
        }
    }
    nextDropdown() {
        const menus = Array.from(this.parentNode.querySelectorAll('.af-global-header-dropdown'));
        const pos = menus.indexOf(this);
        this.focusDropdownByIndex((pos + 1) % menus.length);
    }
    previousDropdown() {
        const menus = Array.from(this.parentNode.querySelectorAll('.af-global-header-dropdown'));
        const pos = menus.indexOf(this);
        this.focusDropdownByIndex((pos ? pos : menus.length) - 1);
    }
    menuUp() {
        this.open = true;
        const listItems = this.getMenuItems();
        const focused = this.getFocusedMenuItem();
        const pos = listItems.indexOf(focused);
        (listItems[pos - 1] || listItems[listItems.length - 1]).focus();
    }
    menuDown() {
        this.open = true;
        const listItems = this.getMenuItems();
        const focused = this.getFocusedMenuItem();
        const pos = listItems.indexOf(focused);
        (listItems[pos + 1] || listItems[0]).focus();
    }
    getMenuItems() {
        return Array.from(this.querySelectorAll('.af-link-list__item'));
    }
    getFocusedMenuItem() {
        return this.getMenuItems().find((item)=>{
            return item.focused;
        });
    }
    gotoMenuItem(item) {
        item._linkRef.click();
    }
    async handleEvents(e) {
        const isNavEvent = this.contains(e.target);
        if (isNavEvent) switch(e.type){
            case 'pointerup':
                if (e.target.nodeName.toUpperCase() === 'AF-LINK-LIST-ITEM') {
                    e.preventDefault();
                    this.gotoMenuItem(e.target);
                } else {
                    e.stopImmediatePropagation();
                    this.open = !this.open;
                }
                break;
            case 'mouseenter':
                if (!this.open) {
                    clearTimeout(this._debounceTimer);
                    this.open = true;
                }
                break;
            case 'mouseleave':
                this._debounceTimer = setTimeout(()=>{
                    this.open = false;
                }, (0, $3ac9a555eacd3098$export$2e2bcd8739ae039).debounce);
                break;
            case 'keydown':
                e.stopPropagation();
                switch(e.keyCode){
                    case 27:
                        this.activeDropdown.open = false;
                        break;
                    case 13:
                    case 32:
                        const focused = this.getFocusedMenuItem();
                        if (focused) this.gotoMenuItem(focused);
                        else this.open = !this.open;
                        break;
                    case 37:
                        e.preventDefault();
                        this.previousDropdown();
                        break;
                    case 39:
                        e.preventDefault();
                        this.nextDropdown();
                        break;
                    case 38:
                        e.preventDefault();
                        this.menuUp();
                        break;
                    case 40:
                        e.preventDefault();
                        this.menuDown();
                        break;
                    default:
                }
                break;
            default:
        }
        else if ($b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._activeDropdown?.open) $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._activeDropdown.open = false;
    }
    get icon() {
        return this.getAttribute('icon');
    }
    set icon(val) {
        this.setAttribute('icon', val);
    }
    get label() {
        return this.getAttribute('label');
    }
    set label(val) {
        this.setAttribute('label', val);
    }
    get panel() {
        return this._panel || '';
    //return this.getAttribute('panel');
    }
    set panel(val) {
        this._panel = val || '';
    //this.setAttribute('panel', val);
    }
    get breakpoint() {
        return this.getAttribute('breakpoint');
    }
    set breakpoint(val) {
        this.setAttribute('breakpoint', val);
    }
    get open() {
        return this.hasAttribute('open');
    }
    set open(val) {
        if (val) {
            this.positionPanel();
            if (this.activeDropdown) this.activeDropdown.open = false;
            this.activeDropdown = this;
            this.setAttribute('open', '');
        } else this.removeAttribute('open');
    }
    get activeDropdown() {
        return $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._activeDropdown || null;
    }
    set activeDropdown(dropdown) {
        $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._activeDropdown = dropdown;
        return this;
    }
    get dropdownList() {
        return $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._menuRegistry || [];
    }
    registerDropdown() {
        $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._menuRegistry = $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._menuRegistry || [];
        $b46ba5220b9486e3$export$931cbfb6bfb85fc.prototype._menuRegistry.push(this);
        return this;
    }
    positionPanel() {
        this._panelRef.style.visibility = 'hidden';
        this._panelRef.style.display = 'block';
        if (this.breakpoint !== 'sm') {
            const viewportWidth = window.document.documentElement.clientWidth;
            const box = this.getBoundingClientRect();
            const position = box.left + box.width / 2 > viewportWidth / 2 + box.width / 2 ? 'left' : 'right';
            const positionClass = `af-global-header-dropdown--menu-position--${position}`;
            if (!this.classList.contains(positionClass)) {
                if (this._previousPosition) this.classList.remove(this._previousPosition);
                this.classList.add(positionClass);
                this._previousPosition = positionClass;
            }
        }
        if (this.breakpoint !== 'sm' && this.classList.contains('af-global-header-dropdown--menu-position--left')) {
            const buttonWidth = this.getBoundingClientRect().width;
            const menuWidth = this._panelRef.getBoundingClientRect().width;
            this._panelRef.style.marginLeft = (menuWidth - buttonWidth) * -1 + 'px';
        } else this._panelRef.style.marginLeft = '0px';
        this._panelRef.style.display = '';
        this._panelRef.style.visibility = '';
    }
    focus() {
        this._buttonRef.focus();
    }
    render() {
        this.innerHTML = `
      <af-global-header-button slot="label" icon="${this.icon}" label="${this.label}" ${this.last ? 'last' : ''}></af-global-header-button>
      ${this.panel}
    `;
        this._buttonRef = this.querySelector('af-global-header-button');
    }
}
class $b46ba5220b9486e3$export$c886254daabbc9a9 extends $b46ba5220b9486e3$export$931cbfb6bfb85fc {
    constructor(){
        super();
        this.label = 'Cirium apps';
        this.icon = 'af-svg-icon-dialpad';
        this.panel = `<af-launcher-menu slot='panel'></af-launcher-menu>`;
        this.render();
    }
}
class $b46ba5220b9486e3$export$5629664e83dab011 extends $b46ba5220b9486e3$export$931cbfb6bfb85fc {
    constructor(){
        super();
        this.label = 'Help';
        this.icon = 'af-svg-icon-help';
        this.panel = "<af-help-menu slot='panel'></af-help-menu>";
        this.render();
    }
}
class $b46ba5220b9486e3$export$f82a7981da43931a extends $b46ba5220b9486e3$export$931cbfb6bfb85fc {
    constructor(){
        super();
        this.last = true;
        this.label = 'Account';
        this.icon = 'af-svg-icon-account';
        this.panel = `<af-account-menu slot='panel'></af-account-menu>`;
        this.render();
    }
    get name() {
        return this.getAttribute('name');
    }
    set name(val) {
        this.setAttribute('name', val);
    }
    get company() {
        return this.getAttribute('company');
    }
    set company(val) {
        this.setAttribute('company', val);
    }
}
const $b46ba5220b9486e3$export$e7a080fe614a8966 = [
    {
        label: 'Dashboard',
        href: 'https://dashboard.cirium.com/app/#/'
    },
    {
        label: 'APIs',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://developer.cirium.com/' : 'https://developer.studios.cirium.dev/'
    },
    {
        label: 'Profiles',
        href: 'https://profiles.cirium.com/'
    },
    {
        label: 'Maintenance Insights',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://groundevents.cirium.com' : 'https://groundevents.cirium.com'
    },
    {
        label: 'Market Alerts',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://market-alerts.cirium.com/alerts' : 'https://market-alerts.staging.cirium.io'
    },
    {
        label: 'Diio Mi',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://mi.diio.net/mi/pages/login.jsp' : 'https://mipreview.diio.net/mi'
    },
    {
        label: 'DIIO beta',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://diio.cirium.com' : 'https://snapshots.cps.cirium.dev'
    },
    {
        label: 'Fleets Analyzer',
        href: 'https://dashboard.cirium.com/app/fleet/#/analyserhome'
    },
    {
        label: 'FlightStats',
        href: 'https://flightstats.com/v2/account/login'
    },
    {
        label: 'Schedule Snapshot',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://diio.cirium.com/snapshots' : 'https://snapshots.cps.cirium.dev/snapshots'
    },
    {
        label: 'SRS Analyzer',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://srsanalyser.diio.net/srs/pages/login.jsp' : 'https://srspreview.diio.net/srs/login'
    },
    {
        label: 'Trip Center',
        href: 'https://trip.flightstats.com/login'
    },
    {
        label: 'Values Analyzer',
        href: 'https://dashboard.cirium.com/app/fleet/#/values/analyserhome'
    },
    {
        label: 'Value Trends',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://profiles.cirium.com/valuetrends' : 'https://profiles.staging.aea.cirium.dev/valuetrends'
    },
    {
        label: 'Asset Watch',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://riskanalytics.cirium.com' : 'https://riskanalytics.gemini.aea.cirium.dev/portfolios'
    },
    {
        label: 'Pulse',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://pulse.cirium.com' : 'https://pulse.staging.aea.cirium.dev/home'
    },
    {
        label: 'Fleet Insights',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://fleet.cirium.com/fleet-distribution' : 'https://fleet.gemini.aea.cirium.dev/fleet-trends'
    },
    {
        label: 'Commercial Aviation Monitor',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://pulse.cirium.com/commercial-aviation-monitor' : 'https://pulse.staging.aea.cirium.dev/commercial-aviation-monitor'
    },
    {
        label: 'Fleet Forecast',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://fleet.cirium.com/commercial-fleet-forecast' : 'https://fleet.apollo.aea.cirium.dev/commercial-fleet-forecast'
    },
    {
        label: 'MRO Profiles',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://groundevents.cirium.com/mro/profiles' : 'https://groundevents.staging.aea.cirium.dev/mro/profiles'
    },
    {
        label: 'Engine Shop Visits Forecast',
        href: (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? 'https://fleet.cirium.com/engine-shop-visit-forecast' : 'https://fleet.staging.aea.cirium.dev/engine-shop-visit-forecast'
    }
];
const $b46ba5220b9486e3$var$ciriumLinks = [
    {
        label: 'Cirium.com',
        href: 'https://cirium.com'
    }
];
class $b46ba5220b9486e3$export$86282f6f5a6c5400 extends (0, $e757bf3008fc0693$export$3c814b55c7cbb1fb).withContext((0, $f8fa9f60bfeb7ba4$export$bec64ed398b2de33)) {
    async connectedCallback() {
        this.render();
        return super.connectedCallback();
    }
    contextChangedCallback() {
        this.render();
    }
    async render() {
        let authenticated = await this.context?.authenticated;
        let profile = null;
        let products = [];
        if (this.context && authenticated) {
            profile = await this.context.getProfile();
            products = profile.products?.map((product)=>{
                return {
                    label: product.title,
                    href: product.url
                };
            });
        }
        const myProducts = this.drawList('My Products', this.alphabetizeByLabel(products));
        const ciriumApps = this.drawList('Cirium Apps', this.alphabetizeByLabel(this.filterList($b46ba5220b9486e3$export$e7a080fe614a8966, products, false)));
        const ciriumPages = authenticated ? this.drawList('Cirium.com', $b46ba5220b9486e3$var$ciriumLinks) : '';
        this.innerHTML = `${myProducts}${ciriumApps}${ciriumPages}`;
    }
    alphabetizeByLabel(list) {
        if (Array.isArray(list) && list.length) return list.sort((a, b)=>{
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
        });
        return list;
    }
    drawList(title, products) {
        if (products && products.length) {
            const header = title ? `<af-link-list-heading>${title}</af-link-list-heading>` : '';
            const links = products.map((app)=>{
                return `<af-link-list-item href="${app.href}">${app.label}</af-link-list-item>`;
            }).join('');
            return `${header}${links}`;
        }
        return '';
    }
    filterList(productList = [], omitList = [], entitled) {
        const omitKeys = omitList?.map((p)=>p.label);
        if (omitKeys) return productList.map((p)=>{
            const { entitledHref: entitledHref, href: href, label: label } = p;
            const calculatedHref = entitled ? entitledHref || href : href;
            return {
                label: label,
                href: calculatedHref
            };
        }).filter((p)=>{
            return !omitKeys.includes(p.label);
        });
        return productList;
    }
}
const $b46ba5220b9486e3$export$75b11740bd04bf36 = [
    {
        label: 'Cirium Help Desk',
        href: 'https://helpdesk.cirium.com/'
    },
    {
        label: 'Contact Support',
        href: 'https://helpdesk.cirium.com/s/contactsupport'
    },
    {
        label: 'Product Status',
        href: 'https://status.cirium.com/'
    }
];
class $b46ba5220b9486e3$export$c95a604f5f13c815 extends (0, $f8fa9f60bfeb7ba4$export$bec64ed398b2de33) {
    constructor(){
        super();
        this.innerHTML = $b46ba5220b9486e3$export$75b11740bd04bf36.map((app)=>{
            return `<af-link-list-item href="${app.href}">${app.label}</af-link-list-item>`;
        }).join('');
    }
}
const $b46ba5220b9486e3$var$accountMenuStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
    ::slotted(.af-account-menu__info),
    ::slotted(.af-account-menu__info-header),
    ::slotted(.af-account-menu__info-subheader){
      font-family: var(--font-family-montserrat) !important;
      display: block;
      text-align: center;
      padding: var(--airframe-space-xl);
      padding-top: var(--airframe-space-xs) !important;
    }
`);
class $b46ba5220b9486e3$export$ff20d75d5eda4388 extends (0, $e757bf3008fc0693$export$3c814b55c7cbb1fb).withContext((0, $288ce109117021f8$export$2e2bcd8739ae039)) {
    constructor(){
        super();
        this.adoptStyle($b46ba5220b9486e3$var$accountMenuStyle);
        this.importTemplate(()=>`<slot></slot>`);
    }
    contextChangedCallback() {
        this.render();
    }
    displayProfileName(user) {
        const firstName = user?.name?.first || '';
        const lastName = user?.name?.last || '';
        const displayName = [];
        if (firstName) displayName.push(firstName);
        if (lastName) displayName.push(lastName);
        return displayName.join(' ');
    }
    async render() {
        const ctx = this.context;
        let authenticated = ctx ? await ctx.authenticated : false;
        let profile = null;
        let logoutUrl = '';
        let signupUrl = '';
        let loginUrl = '';
        if (ctx) {
            if (authenticated) {
                profile = await ctx.getProfile();
                logoutUrl = await ctx.logoutUrl;
            }
            signupUrl = await ctx.signupUrl;
            loginUrl = await ctx.loginUrl;
        }
        if (ctx && logoutUrl) this.innerHTML = `
        ${profile && (profile.name || profile.company) ? `
              <div class="af-account-menu__info">
                <h6 class="heading6 af-account-menu__info-header">${this.displayProfileName(profile)}</h6>
                <span class="footer footnote af-account-menu__info-subheader">${profile.company}</span>
              </div>
              <hr/>
            ` : ''}
        <af-link-list>
          <af-link-list-item href="${(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).myCiriumHost}/flightdeck">Account Flightdeck</af-link-list-item>
          <af-link-list-item href="${(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).myCiriumHost}/my-account/account-overview">Manage account</af-link-list-item>
          <af-link-list-item href="${logoutUrl}">Logout<af-svg-icon-logout></af-svg-icon-logout></af-link-list-item>
        </af-link-list>
      `;
        else if (ctx && loginUrl && signupUrl) this.innerHTML = `
        <af-link-list>
            <af-link-list-item href="${loginUrl}">Login</af-link-list-item>
            <af-link-list-item href="${signupUrl}">Signup</af-link-list-item>
        </af-link-list>
      `;
        else this.innerHTML = `
        <af-link-list>
          <af-link-list-item href="">Loading...</af-link-list-item>
        </af-link-list>
      `;
    }
    async connectedCallback() {
        this.render();
        return super.connectedCallback();
    }
}
window.customElements.define('af-global-header-dropdown', $b46ba5220b9486e3$export$931cbfb6bfb85fc);
window.customElements.define('af-launcher-dropdown', $b46ba5220b9486e3$export$c886254daabbc9a9);
window.customElements.define('af-launcher-menu', $b46ba5220b9486e3$export$86282f6f5a6c5400);
window.customElements.define('af-help-dropdown', $b46ba5220b9486e3$export$5629664e83dab011);
window.customElements.define('af-help-menu', $b46ba5220b9486e3$export$c95a604f5f13c815);
window.customElements.define('af-account-dropdown', $b46ba5220b9486e3$export$f82a7981da43931a);
window.customElements.define('af-account-menu', $b46ba5220b9486e3$export$ff20d75d5eda4388);



/* px value reference from from airframe theme
space.xxxs = rem(2);
space.xxs = rem(4);
space.xs = rem(8);
space.sm = rem(12);
space.md = rem(16);
space.lg = rem(24);
space.xl = rem(32);
space.xxl = rem(40);
space.xxxl = rem(48);
*/ const $a27012663415c1c4$var$style = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
    :host {
      display: block;
        background-color: var(--airframe-color-neutral-grey-80);
        height: var(--airframe-space-xxl);
      position: relative;
      text-align: right;
      border-bottom: 1px var(--airframe-color-neutral-grey-40) solid !important;
      padding: 0px var(--airframe-space-xs) !important;
    }
    
    :host([breakpoint=sm]) {
      padding: 0px var(--airframe-space-sm) !important;
    }
    
    :host([breakpoint=md]),
    :host([breakpoint=lg]) {
      padding: 0px var(--airframe-space-md) !important;
    }

    :host([breakpoint=sm]) af-global-header-spacer {
      display: none;
    }
`);
const $a27012663415c1c4$var$headerTemplate = (vars = {})=>`
  ${!vars.placeHolder ? `
        <af-launcher-dropdown 
          products="${vars.user?.products?.map((p)=>`${p.title}|${p.url}`).join(",") || ""}"
        ></af-launcher-dropdown>
        <af-global-header-spacer></af-global-header-spacer>
        <af-help-dropdown></af-help-dropdown>
        ${(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).hideAccount ? "" : `<af-global-header-spacer></af-global-header-spacer>
        <af-account-dropdown></af-account-dropdown>`}
    ` : ``}
  
`;
class $a27012663415c1c4$export$8545e3c0243374bc extends (0, $288ce109117021f8$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        const font = document.createElement("link");
        font.href = (0, $3ac9a555eacd3098$export$f15d00aa73aafac4)() ? "https://airframe-static.cirium.com/static/fonts/montserrat/css.css" : "https://airframe-static.studios.cirium.dev/static/fonts/montserrat/css.css";
        font.rel = "stylesheet";
        document.head.appendChild(font);
    }
    async connectedCallback() {
        await this.render();
        super.connectedCallback();
        this.adoptStyle($a27012663415c1c4$var$style);
    }
    static observedAttributes = [
        "authenticated"
    ];
    async attributeChangedCallback(_, oldValue, newValue) {
        if (oldValue !== newValue) this.render();
    }
    async render() {
        let authenticated = false;
        // self assign to apply the zIndex
        this.elevate = this.elevate;
        this.importTemplate($a27012663415c1c4$var$headerTemplate, {}, true);
        if (!(0, $3ac9a555eacd3098$export$2e2bcd8739ae039).hideAccount) {
            this.profileClient = await new (0, $7c97e962aaaec607$export$c8be1e13970797d8)({
                //Client-side Auth0
                domain: this.domain,
                clientId: this.clientId,
                audience: this.audience,
                returnTo: this.returnTo,
                //Server-side auth0
                loginUrl: this.loginUrl,
                logoutUrl: this.logoutUrl,
                profileToken: this.profileToken,
                authenticated: this.authenticated
            });
            (0, $e757bf3008fc0693$export$3c814b55c7cbb1fb).value = this.profileClient;
        }
    }
    get domain() {
        return this.getAttribute("domain");
    }
    set domain(val) {
        this.setAttribute("domain", val);
    }
    get returnTo() {
        return this.getAttribute("returnto");
    }
    set returnTo(val) {
        this.setAttribute("returnto", val);
    }
    get elevate() {
        if (this.hasAttribute("elevate")) {
            const val = this.getAttribute("elevate")?.toLowerCase();
            if (val === "false") return false;
            else if (val !== "true") return parseInt(val);
        }
        return 99999;
    }
    set elevate(val) {
        if (val) this.setAttribute("elevate", val);
        else this.setAttribute("elevate", "false");
        this.style.zIndex = this.elevate || "initial";
    }
    get clientId() {
        return this.getAttribute("clientid");
    }
    set clientId(val) {
        this.setAttribute("clientid", val);
    }
    get audience() {
        return this.getAttribute("audience") || "my-cirium";
    }
    set audience(val) {
        this.setAttribute("audience", val);
    }
    get authenticated() {
        return this.hasAttribute("authenticated");
    }
    set authenticated(val) {
        if (val) this.setAttribute("authenticated", "");
        else this.removeAttribute("authenticated");
    }
    get loading() {
        return this.hasAttribute("loading");
    }
    set loading(val) {
        if (val) this.setAttribute("loading", "");
        else this.removeAttribute("loading");
    }
    get profileToken() {
        return this.getAttribute("profiletoken");
    }
    set profileToken(val) {
        this.setAttribute("profiletoken", val);
    }
    get logoutUrl() {
        return this.getAttribute("logouturl");
    }
    set logoutUrl(val) {
        this.setAttribute("logouturl", val);
    }
    get loginUrl() {
        return this.getAttribute("loginurl");
    }
    set loginUrl(val) {
        this.setAttribute("loginurl", val);
    }
}
const $a27012663415c1c4$var$spacerStyle = (0, $d701cedaa1f771ef$export$77500e5680ad5edb)(`
  :host {
    vertical-align: top;
    display: inline-block;
    background-color: var(--airframe-color-neutral-white);
    height: var(--airframe-space-lg);
    width: var(--airframe-space-xxxs);
    margin: var(--airframe-space-xs) 0px;
  }
`);
const $a27012663415c1c4$var$spacerTemplate = ()=>`
  <div></div>
`;
class $a27012663415c1c4$export$4880e44be2a47544 extends (0, $288ce109117021f8$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        this.adoptStyle($a27012663415c1c4$var$spacerStyle);
        this.importTemplate($a27012663415c1c4$var$spacerTemplate);
    }
}
window.customElements.define("af-global-header", $a27012663415c1c4$export$8545e3c0243374bc);
window.customElements.define("af-global-header-spacer", $a27012663415c1c4$export$4880e44be2a47544);
var $a27012663415c1c4$export$2e2bcd8739ae039 = $a27012663415c1c4$export$8545e3c0243374bc;



})();
//# sourceMappingURL=index.js.map
